<template>
  <div
    class="TodoDetails"
  >
    <b-overlay :show="overlayshow" rounded="sm">
        <section class="task-details-section">            
            <div class="details-header">
              <h4 class="details-title">Task Details</h4>
              <!-- *** NEW: Task ID Display (Moved and updated) *** -->
              <div class="task-id-section">
                <span class="mr-1">ID:</span>
                <span class="task-id-text mr-1">{{ task.id }}</span>
                <a href="#" @click.prevent="copyTaskId" title="Copy Task ID" class="copy-button">
                  <i :class="`fa ${copyIconClass}`"></i>
                </a>
              </div>
              <!-- *** END NEW *** -->
            </div>
            <!-- *** REMOVED Original Task ID Display Location *** -->
            
            <div class="card panel task-details-main">    
                <div class="task-details-main-item">
                    <at at="#" :members="patients" name-key="PatientWithDOB" v-if="patients" ref="patientat">
                        <template v-slot:embeddedItem="s">
                            <span>
                            <span :data-teamio-patientid="s.current.PatNum" class="badge mr-xs badge-secondary badge-pill mt-1">
                                <router-link :to="{ name: 'patientprofile', params: { patientID: siteID + '-' + s.current.PatNum }}">{{s.current.Patient}}</router-link>
                            </span>
                            </span>
                        </template>
                        <at at="@" :members="activeEmployees" name-key="Name" v-model="task.content" v-if="employees" ref="empat">
                            <template slot="item" slot-scope="s">
                            <span>{{s.item.Name}}</span>
                            </template>

                            <template slot="embeddedItem" slot-scope="s">
                            <span>
                                <span :data-teamio-employeeid="s.current.EmployeeID" class="badge mr-xs badge-primary badge-pill mt-1">{{s.current.Name}}</span>
                            </span>
                            </template>

                            <div class="todocontent" 
                            ref="newtodo"
                            placeholder="Add your task here..." 
                            contenteditable>
                                {{task.content}}
                            </div>
                        </at>
                    </at>
                </div>  
                <div class="task-details-main-item">
                    <div class="detail-row">
                        <div class="detail-label">Created By:</div>
                        <div class="detail-value">
                            {{this.taskCreatedBy ? this.taskCreatedBy.Name : 'N/A'}}
                        </div>
                    </div>
                </div>  
                
                <div class="task-details-main-item">
                    <div class="detail-row">
                        <div class="detail-label">Assigned To:</div>
                        <div class="detail-value assignee-section">
                            <!-- Read-only view for non-creators -->
                            <div v-if="!isCurrentUserCreator" class="modern-assignees-container">
                               <div class="assignee-avatars">
                                    <div
                                        v-for="assignee in taskAssignees.slice(0, 3).reverse()"
                                        :key="assignee.EmployeeID"
                                        class="avatar"
                                        :class="getAvatarClass(assignee.EmployeeID)"
                                        :title="assignee.Name"
                                    >
                                        <img v-if="getPersonAvatar(assignee.EmployeeID)"
                                             :src="getPersonAvatar(assignee.EmployeeID)"
                                             :alt="assignee.Name"
                                             :class="{ 'avatar-image': true, 'avatar-hidden': avatarLoadError[getPersonAvatar(assignee.EmployeeID)] }"
                                             @error="setAvatarError(getPersonAvatar(assignee.EmployeeID))">
                                        {{ getInitials(assignee.Name) }}
                                    </div>
                                 </div>
                                 <div class="assignee-names">
                                     <!-- Display ALL assignee names -->
                                     <span v-for="assignee in taskAssignees" :key="assignee.EmployeeID" class="assignee-name">
                                         {{ assignee.Name }}
                                     </span>
                                     <!-- Removed the assignee count display -->
                                 </div>
                             </div>
                            <!-- Editable dropdown for the creator -->
                            <div v-else class="assignee-multiselect-wrapper">
                                <multiselect
                                    v-model="selectedAssigneesForEdit" 
                                    :options="activeEmployees"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    :show-labels="false"
                                    label="Name"
                                    track-by="EmployeeID"
                                    placeholder="Select assignees..."
                                    class="assignee-multiselect"
                                >
                                    <template slot="option" slot-scope="props">
                                        <div class="assignee-option">
                                            <!-- Use .avatar class instead of .avatar-circle.small-avatar -->
                                            <div class="avatar" :class="getAvatarClass(props.option.EmployeeID)">
                                                 <img v-if="getPersonAvatar(props.option.EmployeeID)"
                                                      :src="getPersonAvatar(props.option.EmployeeID)"
                                                      :alt="props.option.Name"
                                                      :class="{ 'avatar-image': true, 'avatar-hidden': avatarLoadError[getPersonAvatar(props.option.EmployeeID)] }"
                                                      @error="setAvatarError(getPersonAvatar(props.option.EmployeeID))">
                                                 {{ getInitials(props.option.Name) }}
                                            </div>
                                            <span class="assignee-option-name">{{ props.option.Name }}</span>
                                        </div>
                                    </template>
                                    <template slot="tag" slot-scope="{ option, remove }">
                                        <span class="multiselect__tag assignee-tag">
                                             <!-- Use .avatar class instead of .avatar-circle.small-avatar -->
                                             <div class="avatar" :class="getAvatarClass(option.EmployeeID)">
                                                 <img v-if="getPersonAvatar(option.EmployeeID)"
                                                      :src="getPersonAvatar(option.EmployeeID)"
                                                      :alt="option.Name"
                                                      :class="{ 'avatar-image': true, 'avatar-hidden': avatarLoadError[getPersonAvatar(option.EmployeeID)] }"
                                                      @error="setAvatarError(getPersonAvatar(option.EmployeeID))">
                                                 {{ getInitials(option.Name) }}
                                            </div>
                                            <span>{{ option.Name }}</span>
                                            <i tabindex="1" class="multiselect__tag-icon" @click="remove(option)"></i>
                                        </span>
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                </div>  
                
                <div class="task-details-main-item">
                    <div class="detail-row">
                        <div class="detail-label">Patients:</div>
                        <div class="detail-value">
                            <div class="modern-patients-container" v-if="taskPatients && taskPatients.length > 0">
                                <div class="patient-tags">
                                    <span 
                                        v-for="patient in taskPatients" 
                                        :key="patient.id" 
                                        class="patient-tag"
                                    >
                                        <i class="fa fa-user-circle patient-icon"></i> {{ patient.name }}
                                    </span>
                                </div>
                                <!-- Removed the patient count display -->
                            </div>
                            <div v-else class="no-patients">No patients associated with this task</div>
                        </div>
                    </div>
                </div>
                
                <div class="task-details-main-item">
                    <div class="detail-row">
                        <div class="detail-label">Tags:</div>
                        <div class="detail-value">
                            <!-- Replace static tags with multiselect -->
                            <multiselect
                                v-model="selectedTagsForEdit"
                                :options="computedAvailableTags || []"
                                :multiple="true"
                                :taggable="true"
                                placeholder="Add or edit tags..."
                                @tag="addTag"
                                class="tag-input-details"
                            >
                                <!-- Optional: Custom template for tags if needed -->
                                <template slot="tag" slot-scope="{ option, remove }">
                                    <span class="multiselect__tag">
                                        <span>{{ option }}</span>
                                        <i tabindex="1" class="multiselect__tag-icon" @click="remove(option)"></i>
                                    </span>
                                </template>
                                <template slot="option" slot-scope="props">
                                    <!-- Handle both string options and potential object for new tag suggestion -->
                                    <span>{{ typeof props.option === 'object' && props.option.label ? props.option.label : props.option }}</span>
                                </template>

                            </multiselect>
                            <!-- Display repeat frequency separately if needed -->
                            <span v-if="task.repeat && task.repeatFrequency" class="tag-item repeat-tag mt-2 d-inline-block">
                                {{ formatRepeatFrequency(task.repeatFrequency) }}
                            </span>
                        </div>
                    </div>
                </div>
                
                <div class="task-details-main-item">
                    <div class="detail-row">
                        <div class="detail-label">Due On:</div>
                        <div class="detail-value date-value">
                            <span class="due-date">{{task.dueAt | dateformat(dateFormatStr)}}</span>
                        </div>
                    </div>
                </div>

                <!-- *** NEW: Status Display Row *** -->
                <div class="task-details-main-item">
                  <div class="detail-row">
                    <div class="detail-label">Status:</div>
                    <div class="detail-value">
                      <span v-if="isCompletedTask" class="status-badge status-badge-completed">Completed</span>
                      <span v-else-if="isOverdue" class="status-badge status-badge-overdue">Overdue</span>
                      <span v-else class="status-badge status-badge-incomplete">Incomplete</span>
                    </div>
                  </div>
                </div>
                <!-- *** END NEW *** -->

                <div class="task-details-main-item" v-if="task.completedAt && task.completedAt !== ''">
                    <div class="detail-row">
                        <div class="detail-label">Completed On:</div>
                        <div class="detail-value">
                            <span class="completed-date">{{task.completedAt | dateformat(dateFormatStr)}}</span>
                        </div>
                    </div>
                </div>

                <div class="task-details-main-item" v-if="task.status === 'COMPLETED' && task.completedByEmpID">
                    <div class="detail-row">
                        <div class="detail-label">Completed By:</div>
                        <div class="detail-value">
                            <multiselect
                                v-if="this.employees"
                                v-model="taskCompletedBy"
                                :options="activeEmployees"
                                :multiple="false"
                                :taggable="false"
                                :show-labels="false"
                                label="Name"
                                track-by="Name"
                                aria-placeholder
                                disabled                            
                            />
                        </div>
                    </div>
                </div>  

                <div class="task-details-main-item date-picker-container compact-layout">
                    <div class="date-picker-header">
                        <h6 class="date-picker-title">Due Date</h6>
                        <a href="#" class="repeat-link" @click="setRepeat(task, true)">
                            Set to repeat
                        </a>
                    </div>
                    <div class="date-picker-row">
                        <div class="calendar-container">
                            <vuejs-datepicker
                                v-model="task.dueAt"
                                @selected="updateDueAt"
                                :disabled-dates="disabledDates"
                                :format="formatDateForDisplay"
                                :inline="true"
                                class="modal-date compact-calendar"
                            ></vuejs-datepicker>
                        </div>
                        
                        <div class="repeat-options compact-repeat" v-show="task.repeat">
                            <div class="repeat-form">
                                <div class="repeat-frequency">
                                    <label>Repeat</label>
                                    <select class="repeat-select-fixed" v-model="task.repeatFrequency" @change="onRepeatChange(task)">
                                        <option value="Never">Never</option>
                                        <option value="Daily">Daily</option>
                                        <option value="Weekly">Weekly</option>
                                        <option value="Bi-Weekly">Bi-Weekly</option>
                                        <option value="Monthly">Monthly</option>
                                        <option value="Yearly">Yearly</option>
                                    </select>
                                </div>

                                  <div class="daily-options" v-if="task.repeatFrequency==='Daily'">
                                      <div class="exclude-days">
                                          <div class="exclude-label">Exclude days:</div>
                                          <div class="exclude-checkboxes">
                    <b-form-group class="abc-checkbox">
                        <b-form-checkbox
                            v-model="task.excludeSaturday"
                            @change="onExcludeDaysChange"
                        >
                            <span class="fw-semi-bold">Exclude Saturday</span>
                        </b-form-checkbox>
                    </b-form-group>
                    <b-form-group class="abc-checkbox">
                        <b-form-checkbox
                            v-model="task.excludeSunday"
                            @change="onExcludeDaysChange"
                        >
                            <span class="fw-semi-bold">Exclude Sunday</span>
                        </b-form-checkbox>
                    </b-form-group>
                                          </div>
                                      </div>
                                  </div>

                                <div class="weekly-options" v-if="task.repeatFrequency==='Weekly' || task.repeatFrequency==='Bi-Weekly'">                        
                                    <div class="days-of-week">
                                        <div class="days-label">Repeat on:</div>
                                        <div class="day-buttons">
                                            <b-form-radio-group
                                                v-model="task.repeatOn"
                                                :options="weeklyIntervalOptions"
                                                class="day-select-group"
                                                value-field="value"
                                                text-field="text"
                                                disabled-field="notEnabled"
                                                buttons
                                                button-variant="outline-secondary"
                                                size="sm"
                                            ></b-form-radio-group>
                                        </div>
                                    </div>
                                </div>

                                <div class="monthly-options" v-if="task.repeatFrequency==='Monthly'">
                                    <div class="monthly-day-select">
                                        <label>On day</label>
                                        <select class="repeat-select-fixed" v-model="computedRepeatOnDay" :disabled="isDayOfMonthDisabled">
                                            <option value="">Select a day</option>
                                            <option v-for="n in 31" :key="n" :value="n">{{ n }}</option>
                                        </select>
                                        <span class="day-label">of the month</span>
                                    </div>

                                    <div class="last-day-option">
                                        <div class="last-day-checkbox-container">
                                            <b-form-checkbox 
                                              :checked="task.repeatOnLastDayOfMonth === true" 
                                              @change="toggleLastDayOfMonthMonthly"
                                              class="mb-2">
                                              Repeat on Last Day of the Month
                                            </b-form-checkbox>
                                        </div>
                                        <i id="lastdayofmonth" class="fa fa-question-circle info-icon"></i>
                                        <b-tooltip target="lastdayofmonth" placement="top" triggers="hover">
                                            Checking this option will automatically select the last day of every month
                                        </b-tooltip>
                                    </div>
                                </div>

                                <div class="yearly-options" v-if="task.repeatFrequency==='Yearly'">
                                    <div class="yearly-day-select">
                                        <label>On</label>
                                        <select class="repeat-select-fixed" v-model="computedRepeatOnDay" :disabled="isDayOfMonthDisabled">
                                            <option v-for="n in 31" :key="n" :value="n">{{ n }}</option>
                                        </select>
                                        <sup>th</sup> day of 
                                        <select class="repeat-select-fixed month-select" v-model="computedRepeatOnMonth">
                                            <option v-for="month in months" :key="month.val" :value="month.val">{{ month.month }}</option>
                                        </select>
                                    </div>

                                    <div class="last-day-option">
                                        <div class="last-day-checkbox-container">
                                            <b-form-checkbox 
                                              :checked="task.repeatOnLastDayOfMonth === true" 
                                              @change="toggleLastDayOfMonthYearly" 
                                              class="mt-2">
                                              Repeat on Last Day of the Month
                                            </b-form-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- SUBTASKS SECTION -->
            <div class="card panel task-details-item subtasks-section">
                <div role="button" class="card-header panel-header accordion-toggle cursor-pointer task-details-item-header" @click="toggleBlock(5)">
                    <h6 class="section-title">
                        <i class="fa fa-list-ul section-icon"></i> Subtasks
                        <span class="new-feature-badge">New</span>
                        <span v-if="subtasks && subtasks.length > 0" class="subtask-progress-badge">
                            {{ completedSubtasksCount }}/{{ subtasks.length }}
                        </span>
                    </h6>
                    <i :class="`toggle-icon fa fa-angle-down ${this.isShown[5] ? 'expanded' : ''}`"></i>
                </div>
                <b-collapse id="accordion-subtasks" class="panel-body subtasks-panel" :visible="this.isShown[5]">
                    <div class="subtasks-container">
                        <!-- Progress Bar -->
                        <div v-if="subtasks && subtasks.length > 0" class="subtasks-progress">
                            <div class="progress-bar-container">
                                <div class="progress-bar-fill" :style="{ width: subtaskProgressPercent + '%' }"></div>
                            </div>
                            <span class="progress-text">{{ subtaskProgressPercent }}% complete</span>
                        </div>

                        <!-- Subtask List with Drag & Drop -->
                        <draggable
                            v-model="subtasks"
                            class="subtask-list"
                            handle=".subtask-drag-handle"
                            ghost-class="subtask-ghost"
                            animation="200"
                            @end="onSubtaskReorder"
                        >
                            <div v-for="(subtask, index) in subtasks" :key="subtask.id || index" class="subtask-item" :class="{ 'subtask-completed': subtask.status === 'COMPLETED' }">
                                <div class="subtask-drag-handle" title="Drag to reorder">
                                    <i class="fa fa-grip-vertical"></i>
                                </div>
                                <div class="subtask-checkbox-wrapper">
                                    <button
                                        class="subtask-checkbox"
                                        :class="{ 'is-checked': subtask.status === 'COMPLETED' }"
                                        @click="toggleSubtaskStatus(index)"
                                        type="button"
                                        aria-label="Toggle subtask completion"
                                    >
                                        <i :class="['fa', subtask.status === 'COMPLETED' ? 'fa-check-circle' : 'fa-circle-o']"></i>
                                    </button>
                                </div>
                                <div class="subtask-content" :class="{ 'completed-text': subtask.status === 'COMPLETED' }">
                                    {{ subtask.content }}
                                </div>
                                <button class="subtask-delete-btn" @click="deleteSubtask(index)" title="Delete subtask">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </draggable>

                        <!-- Empty State -->
                        <div v-if="!subtasks || subtasks.length === 0" class="subtasks-empty">
                            <i class="fa fa-tasks empty-icon"></i>
                            <p>No subtasks yet</p>
                            <span class="empty-hint">Break this task into smaller steps</span>
                        </div>

                        <!-- Add Subtask Input -->
                        <div class="add-subtask-container">
                            <div class="add-subtask-input-wrapper">
                                <i class="fa fa-plus add-icon"></i>
                                <input
                                    type="text"
                                    v-model="newSubtaskContent"
                                    @keyup.enter="addSubtask"
                                    placeholder="Add a subtask..."
                                    class="add-subtask-input"
                                />
                            </div>
                            <button 
                                class="add-subtask-btn" 
                                @click="addSubtask"
                                :disabled="!newSubtaskContent || !newSubtaskContent.trim()"
                            >
                                Add
                            </button>
                        </div>
                    </div>
                </b-collapse>
            </div>
            <!-- END SUBTASKS SECTION -->
            
            <div class="card panel task-details-item">
                <div role="button" class="card-header panel-header accordion-toggle cursor-pointer task-details-item-header" @click="toggleBlock(2)">
                    <h6 class="section-title">
                        <i class="fa fa-file-text-o section-icon"></i> Attach a Wiki
                        <span v-if="selectedWikiPages && selectedWikiPages.length > 0" class="wiki-count-badge">
                            {{ selectedWikiPages.length }} {{ selectedWikiPages.length === 1 ? 'document' : 'documents' }}
                        </span>
                    </h6>
                    <i :class="`toggle-icon fa fa-angle-down ${this.isShown[2] ? 'expanded' : ''}`"></i>
                </div>
                <b-collapse id="accordion-wiki" class="panel-body attachment-panel" :visible="this.isShown[2]">
                    <div class="wiki-container">
                        <h6 class="no-wiki-message" v-if="!this.wikiPages || this.wikiPages.length === 0">
                            You don't have any wiki pages created yet. <router-link to="/app/wiki">Create a new Wiki Page</router-link>
                        </h6>
                        
                        <!-- Selected Wiki Pages List -->
                        <div v-if="selectedWikiPages && selectedWikiPages.length > 0" class="selected-wikis-container">
                            <h6 class="selected-wiki-title">Selected Wiki Pages:</h6>
                            <ul class="wiki-list">
                                <li v-for="page in selectedWikiPages" :key="page.WikiPageID" class="wiki-item">
                                    <i class="fa fa-file-text-o wiki-icon"></i>
                                    <router-link :to="{ name: 'WikiView', params: {wikiPageID: `${page.WikiPageID}`} }" target="_blank" class="wiki-link">
                                        {{page.Name}}
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                        
                        <!-- Wiki Dropdown -->
                        <div class="wiki-dropdown-section">
                            <div v-if="this.wikiPages && this.wikiPages.length > 0" class="wiki-dropdown-container">
                                <label class="wiki-dropdown-label">Add wiki pages:</label>
                                <div class="wiki-multiselect-wrapper">
                                    <multiselect
                                        v-model="selectedWikiPages"
                                        :options="wikiPages"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        :show-labels="false"
                                        label="Name"
                                        track-by="WikiPageID"
                                        placeholder="Select wiki pages..."
                                        class="wiki-multiselect"
                                    >
                                        <template slot="option" slot-scope="props">
                                            <div class="wiki-option">
                                                <i class="fa fa-file-text-o wiki-option-icon"></i>
                                                <span class="wiki-option-name">{{ props.option.Name }}</span>
                                            </div>
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-collapse>
            </div>

            <div class="card panel task-details-item" v-if="this.siteID === '4dd2fc2c-d7cb-11e9-bac0-0ad6daef1536' || this.siteID === '437dd9f9-7850-11ea-ac82-160d1264b43d'">
                <div role="button" class="card-header panel-header accordion-toggle cursor-pointer task-details-item-header" @click="toggleBlock(3)">
                    <h6 class="section-title"><i class="fa fa-google section-icon"></i> Attach a Google Document
                    <span class="new-feature-badge">New</span></h6>
                    <i :class="`toggle-icon fa fa-angle-down ${this.isShown[3] ? 'expanded' : ''}`"></i>
                </div>

                <b-collapse id="accordion-assets" class="panel-body" :visible="this.isShown[3]">
                    <div class="mb-4">
                        <b-button v-if="!isDemoSession" variant="success" type="submit" class="btn-sm ml-5" @click="importFromGoogle">Import from Google</b-button>
                    </div>
                </b-collapse>
            </div>

            <div class="card panel task-details-item">
                <div role="button" class="card-header panel-header accordion-toggle cursor-pointer task-details-item-header" @click="toggleBlock(4)">
                    <h6 class="section-title">
                        <i class="fa fa-comments section-icon"></i> Comments
                        <span v-if="task.comments && task.comments.length > 0" class="comment-count-badge">
                            {{ task.comments.length }} {{ task.comments.length === 1 ? 'comment' : 'comments' }}
                        </span>
                    </h6>
                    <i :class="`toggle-icon fa fa-angle-down ${this.isShown[4] ? 'expanded' : ''}`"></i>
                </div>
                
                <b-collapse id="accordion-comments" class="panel-body comments-panel" :visible="this.isShown[4]"> 
                    <div class="comments-container">
                        <div class="comment-list">
                            <div v-for="(comment, index) in paginatedComments" :key="`${comment.id}-${index}`" class="comment-item">
                                <div class="comment-avatar">
                                    <div class="avatar-circle" :class="getAvatarClass(comment.employeeID)">
                                         <img v-if="getPersonAvatar(comment.employeeID)"
                                              :src="getPersonAvatar(comment.employeeID)"
                                              :alt="getEmployeeName(comment.employeeID)"
                                              :class="{ 'avatar-image': true, 'avatar-hidden': avatarLoadError[getPersonAvatar(comment.employeeID)] }"
                                              @error="setAvatarError(getPersonAvatar(comment.employeeID))">
                                        {{ getInitials(getEmployeeName(comment.employeeID)) }}
                                    </div>
                                </div>
                                <div class="comment-content">
                                    <div class="comment-header">
                                        <span class="comment-author">{{getEmployeeName(comment.employeeID)}}</span>
                                        <span class="comment-time">{{comment.createdAt | dateformatwithtime}}</span>
                                    </div>
                                    <div class="comment-text">{{comment.text}}</div>
                                </div>
                            </div>
                        </div>
                        
                        <div v-if="totalPages > 1" class="pagination-container">
                            <button 
                                class="pagination-btn" 
                                :disabled="currentPage === 1"
                                @click="currentPage--"
                            >
                                <i class="fa fa-chevron-left"></i>
                            </button>
                            <span class="pagination-info">{{currentPage}} / {{totalPages}}</span>
                            <button 
                                class="pagination-btn" 
                                :disabled="currentPage === totalPages"
                                @click="currentPage++"
                            >
                                <i class="fa fa-chevron-right"></i>
                            </button>
                        </div>
                        
                        <div class="new-comment">
                            <div class="comment-avatar">
                                <div class="avatar-circle" :class="getAvatarClass(userID)">
                                     <img v-if="getPersonAvatar(userID)"
                                          :src="getPersonAvatar(userID)"
                                          :alt="user.Name"
                                          :class="{ 'avatar-image': true, 'avatar-hidden': avatarLoadError[getPersonAvatar(userID)] }"
                                          @error="setAvatarError(getPersonAvatar(userID))">
                                    {{ getInitials(user.Name) }}
                                </div>
                            </div>
                            <div class="comment-input-container">
                                <textarea 
                                    v-model="commentText" 
                                    rows="3" 
                                    placeholder="Write your comment here..." 
                                    class="comment-input"
                                ></textarea>
                                
                                <div class="comment-options">
                                    <b-form-checkbox
                                        v-model="saveToCommLog"
                                        unchecked-value="FALSE"
                                        value="TRUE"
                                        class="commlog-option"
                                        @change="onSaveToCommLogChange"
                                    >
                                    Save to CommLog
                                    </b-form-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-collapse>
            </div>

            <div class="details-footer">
                <b-button
                    :variant="isCompletedTask ? 'outline-warning' : 'success'"
                    @click="toggleTaskStatus"
                    class="action-button complete-toggle-button"
                >
                    <i :class="isCompletedTask ? 'fa fa-undo' : 'fa fa-check-circle'"></i>
                    {{ isCompletedTask ? 'Mark Incomplete' : 'Mark Complete' }}
                </b-button>
                <b-button variant="primary" type="submit" @click="save" class="action-button save-button">
                    <i class="fa fa-check"></i> Save Changes
                </b-button>
                <b-button variant="outline-secondary" @click="setErrored2(false);setMessage2('');$emit('closePanel', {});" class="action-button cancel-button">
                    Cancel
                </b-button>
            </div>
        </section>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */

import Vue from 'vue';
import DatePicker from "vue2-datepicker";
import vuejsDatepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";
import PopupErrorDisplay from "@/components/ErrorDisplay/PopupErrorDisplay";
import moment from 'moment-timezone';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import At from '../vueat/At';
import mixin from '../../../mixin.js';
import GoogleImport from "@/components/GoogleImport/GoogleImport.vue";
import draggable from 'vuedraggable';
import _ from 'lodash';
// Aliased so the delegating getTaggedPatientIDs() method below can't be mistaken for recursion.
import { getTaggedPatientIDs as parseTaggedPatientIDs } from '@/utils/taskPatients';

export default {
    name: 'TodoDetails',
    components: { DatePicker, Multiselect, PopupErrorDisplay, At, vuejsDatepicker, draggable },
    mixins: [mixin],
    props: {
        task: {
            type: Object,
            required: true
        },
        wikiPages: {
            type: Array,
            default: () => []
        },
        siteTags: { // Add siteTags prop
            type: Array,
            default: () => []
        },
        // Removed duplicate siteTags prop definition
    },

    mounted() {
        // Debug: Log the task prop on mount
        // console.log('TodoDetails Mounted - Task Prop:', JSON.parse(JSON.stringify(this.task)));
        // console.log('Specifically, task.repeatOnLastDayOfMonth:', this.task?.repeatOnLastDayOfMonth);
        
        this.adjustTextareaHeight();
        // Initialize local state from props
        // Initialization moved to task watcher
    },

    created() {
        // Initialization moved to task watcher
    },

    data(){
        return {
            overlayshow: false,
            isShown: {0: true, 1: true, 2: false, 3: false, 4: true, 5: true},
            commentText: '',
            showDatePopover: false,
            selectedWikiPages: [],
            selectedAssigneesForEdit: [], // Explicitly declare here
            selectedTagsForEdit: [], // Add data property for tags
            avatarLoadError: {}, // <-- Added Data Property
            weeklyIntervalOptions: [
                { text: 'Sun', value: 'Sun', disabled: false },
                { text: 'Mon', value: 'Mon', disabled: false },
                { html: 'Tue', value: 'Tue', disabled: true },
                { text: 'Wed', value: 'Wed', disabled: false },
                { text: 'Thurs', value: 'Thurs', disabled: false },
                { text: 'Fri', value: 'Fri', disabled: false },
                { text: 'Sat', value: 'Sat', disabled: false }
            ],
            months: [
                {month: 'January', val: 1},
                {month: 'February', val: 2},
                {month: 'March', val: 3},
                {month: 'April', val: 4},
                {month: 'May', val: 5},
                {month: 'June', val: 6},
                {month: 'July', val: 7},
                {month: 'August', val: 8},
                {month: 'September', val: 9},
                {month: 'October', val: 10},
                {month: 'November', val: 11},
                {month: 'December', val: 12},
            ],
            originalAssigneeID: null,
            originalAssignees: null,
            saveToCommLog: "FALSE",
            isDayOfMonthDisabled: false,
            avatarColors: [
                'bg-primary', 'bg-success', 'bg-info', 'bg-warning',
                'bg-danger', 'bg-gray', 'bg-gray-dark', 'bg-gray-light'
            ],
            currentPage: 1,
            commentsPerPage: 5,
            fullMonths: [
                {month: 'January', val: 1}, {month: 'February', val: 2}, {month: 'March', val: 3},
                {month: 'April', val: 4}, {month: 'May', val: 5}, {month: 'June', val: 6},
                {month: 'July', val: 7}, {month: 'August', val: 8}, {month: 'September', val: 9},
                {month: 'October', val: 10}, {month: 'November', val: 11}, {month: 'December', val: 12},
            ],
            copyIconClass: 'fa-clipboard', // Added for copy button state
            // Subtasks data
            subtasks: [],
            newSubtaskContent: ''
        }
    },

    methods: {
        // 'updateTaskWithComment' was mapped here until 2026-09-22 but bce2d042 deleted that
        // action in 2025 — the mapping resolved to nothing and no call site was left.
        ...mapActions('tasks', ['updateTask', 'updateTaskSubtasks']),
        ...mapActions('alert', ['setDismissSuccessCountDown', 'setErrored2', 'setMessage2']),
        ...mapActions('tasks', ['addTaskComment', 'addTaskAssignmentNotifications']), // Added mapping

        // Helper method to initialize selected wiki pages
        initializeWikiPages(task) {
            if (task && task.wikiPages && this.wikiPages && this.wikiPages.length > 0) {
                const taskWikiPageIds = Array.isArray(task.wikiPages)
                    ? task.wikiPages
                    : (typeof task.wikiPages === 'string' ? [task.wikiPages] : []);

                this.selectedWikiPages = this.wikiPages.filter(page => {
                    return taskWikiPageIds.some(id => String(page.WikiPageID) === String(id));
                });
                // console.log("Initialized/Updated selectedWikiPages:", this.selectedWikiPages);
            } else {
                this.selectedWikiPages = [];
            }
             // Set initial collapse state for wiki section
             this.$nextTick(() => {
                 Vue.set(this.isShown, 2, this.selectedWikiPages && this.selectedWikiPages.length > 0);
             });
        },

        // Helper method to initialize selected wiki pages
        initializeWikiPages(task) {
            if (task && task.wikiPages && this.wikiPages && this.wikiPages.length > 0) {
                const taskWikiPageIds = Array.isArray(task.wikiPages)
                    ? task.wikiPages
                    : (typeof task.wikiPages === 'string' ? [task.wikiPages] : []);

                this.selectedWikiPages = this.wikiPages.filter(page => {
                    return taskWikiPageIds.some(id => String(page.WikiPageID) === String(id));
                });
                console.log("Initialized/Updated selectedWikiPages:", this.selectedWikiPages);
            } else {
                this.selectedWikiPages = [];
            }
             // Set initial collapse state for wiki section
             this.$nextTick(() => {
                 Vue.set(this.isShown, 2, this.selectedWikiPages && this.selectedWikiPages.length > 0);
             });
        },

        // Helper method to initialize selected wiki pages
        initializeWikiPages(task) {
            if (task && task.wikiPages && this.wikiPages && this.wikiPages.length > 0) {
                const taskWikiPageIds = Array.isArray(task.wikiPages)
                    ? task.wikiPages
                    : (typeof task.wikiPages === 'string' ? [task.wikiPages] : []);

                this.selectedWikiPages = this.wikiPages.filter(page => {
                    return taskWikiPageIds.some(id => String(page.WikiPageID) === String(id));
                });
                console.log("Initialized/Updated selectedWikiPages:", this.selectedWikiPages);
            } else {
                this.selectedWikiPages = [];
            }
             // Set initial collapse state for wiki section
             this.$nextTick(() => {
                 Vue.set(this.isShown, 2, this.selectedWikiPages && this.selectedWikiPages.length > 0);
             });
        },

        // Helper method to initialize selected wiki pages
        initializeWikiPages(task) {
            if (task && task.wikiPages && this.wikiPages && this.wikiPages.length > 0) {
                const taskWikiPageIds = Array.isArray(task.wikiPages)
                    ? task.wikiPages
                    : (typeof task.wikiPages === 'string' ? [task.wikiPages] : []);

                this.selectedWikiPages = this.wikiPages.filter(page => {
                    return taskWikiPageIds.some(id => String(page.WikiPageID) === String(id));
                });
                console.log("Initialized/Updated selectedWikiPages:", this.selectedWikiPages);
            } else {
                this.selectedWikiPages = [];
            }
             // Set initial collapse state for wiki section
             this.$nextTick(() => {
                 Vue.set(this.isShown, 2, this.selectedWikiPages && this.selectedWikiPages.length > 0);
             });
        },


        addTag(newTag) {
          // The multiselect component handles adding the tag via v-model binding.
          // This method ensures the tag is added to our local array if needed,
          // although direct v-model manipulation by multiselect might make this redundant.
          // We only need to ensure the tag is added to the selection for *this* task.
          // Add to selected tags for this task
          // Relying on v-model binding to update selectedTagsForEdit.
          // The check below might still be useful for logging or complex logic,
          // but the push operation itself is likely handled by v-model.
          if (!this.selectedTagsForEdit?.includes(newTag)) { // Added optional chaining for safety
             // console.log(`@tag event: Adding new tag '${newTag}' to selection.`);
             this.selectedTagsForEdit.push(newTag); // RESTORED: Manually add the new tag from the @tag event
          } else {
             // console.log(`@tag event: Tag '${newTag}' might already be in selection.`);
          }
        },

        // ============================================
        // SUBTASK METHODS (with auto-save)
        // ============================================
        generateSubtaskId() {
            // Generate a unique ID for subtasks using timestamp + random string
            return `st_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
        },

        // Auto-save subtasks to Firestore
        async autoSaveSubtasks() {
            if (!this.task || !this.task.id) {
                console.warn('Cannot auto-save subtasks: no task ID');
                return;
            }

            try {
                await this.updateTaskSubtasks({
                    taskId: this.task.id,
                    subtasks: this.subtasks
                });
                // Subtle success feedback (optional - can show a small checkmark or nothing)
                // console.log('Subtasks auto-saved');
            } catch (err) {
                console.error('Failed to auto-save subtasks:', err);
                this.$toast.error('Failed to save subtask changes. Please try again.');
            }
        },

        // Debounced version for rapid changes (like drag & drop reorder)
        debouncedAutoSaveSubtasks: _.debounce(function() {
            this.autoSaveSubtasks();
        }, 500),

        async addSubtask() {
            if (!this.newSubtaskContent || !this.newSubtaskContent.trim()) {
                return;
            }

            const newSubtask = {
                id: this.generateSubtaskId(),
                content: this.newSubtaskContent.trim(),
                status: 'INCOMPLETE',
                sortOrder: this.subtasks.length,
                createdAt: new Date()
            };

            this.subtasks.push(newSubtask);
            this.newSubtaskContent = ''; // Clear input

            // Auto-save immediately after adding
            await this.autoSaveSubtasks();
        },

        async toggleSubtaskStatus(index) {
            if (index < 0 || index >= this.subtasks.length) return;

            const subtask = this.subtasks[index];
            const newStatus = subtask.status === 'COMPLETED' ? 'INCOMPLETE' : 'COMPLETED';

            // Use Vue.set for reactivity
            this.$set(this.subtasks, index, {
                ...subtask,
                status: newStatus,
                completedAt: newStatus === 'COMPLETED' ? new Date() : null,
                completedByEmpID: newStatus === 'COMPLETED' ? this.userID : null
            });

            // Auto-save after toggling status
            await this.autoSaveSubtasks();
        },

        async deleteSubtask(index) {
            if (!this.subtasks || index < 0 || index >= this.subtasks.length) return;

            this.subtasks.splice(index, 1);

            // Auto-save after deletion
            await this.autoSaveSubtasks();
        },

        moveSubtaskUp(index) {
            if (!this.subtasks || index <= 0 || index >= this.subtasks.length) return;

            // Swap with the item above
            const temp = this.subtasks[index];
            this.$set(this.subtasks, index, this.subtasks[index - 1]);
            this.$set(this.subtasks, index - 1, temp);

            // Use debounced save for reordering (in case user does multiple moves)
            this.debouncedAutoSaveSubtasks();
        },

        moveSubtaskDown(index) {
            if (!this.subtasks || index < 0 || index >= this.subtasks.length - 1) return;

            // Swap with the item below
            const temp = this.subtasks[index];
            this.$set(this.subtasks, index, this.subtasks[index + 1]);
            this.$set(this.subtasks, index + 1, temp);

            // Use debounced save for reordering (in case user does multiple moves)
            this.debouncedAutoSaveSubtasks();
        },

        // Handler for drag & drop reorder (called by draggable @end event)
        onSubtaskReorder() {
            // Use debounced save after drag & drop
            this.debouncedAutoSaveSubtasks();
        },
        // ============================================
        // END SUBTASK METHODS
        // ============================================

        formatDateForDisplay(date) {
            return moment(date).format('MM/DD/YYYY');
        },

        updateDueAt(date) {
            if (date && this.task) {
                this.task.dueAt = date;
                this.task.dueAtStr = moment(date).format('MM/DD/YYYY');
            }
        },

        setRepeat(task, repeatType) {
            if (this.task) {
                // Create a copy of the current task to preserve all properties
                const updatedTask = { ...this.task };
                // Set the repeat flag
                updatedTask.repeat = repeatType;
                // If setting repeat to true, set a default frequency
                if (repeatType) {
                    updatedTask.repeatFrequency = updatedTask.repeatFrequency || 'Daily';
                    // Initialize exclude day properties if they don't exist
                    if (updatedTask.excludeSaturday === undefined) {
                        updatedTask.excludeSaturday = false;
                    }
                    if (updatedTask.excludeSunday === undefined) {
                        updatedTask.excludeSunday = false;
                    }
                }
                // Use selectedTagsForEdit instead of task.tags to preserve newly added tags
                updatedTask.tags = [...this.selectedTagsForEdit];
                // Update the task reactively
                Object.keys(updatedTask).forEach(key => {
                    Vue.set(this.task, key, updatedTask[key]);
                });
            }
        },

        onRepeatChange(task) {
            if (task && task.repeatFrequency === "Never") {
                task.repeat = false;
                this.clearDate(task);
            }
        },

        onExcludeDaysChange() {
            // Immediately adjust due date if it conflicts with newly selected exclude days
            if (this.task && this.task.repeat && this.task.repeatFrequency === 'Daily' && this.task.dueAt) {
                const excludedDays = [];
                if (this.task.excludeSaturday) excludedDays.push('Saturday');
                if (this.task.excludeSunday) excludedDays.push('Sunday');
                
                if (excludedDays.length > 0) {
                    let adjustedDueDate = moment(this.task.dueAt);
                    const originalDate = adjustedDueDate.format('MM/DD/YYYY');
                    
                    // Keep advancing the date until we find a non-excluded day
                    while (excludedDays.includes(adjustedDueDate.format('dddd'))) {
                        adjustedDueDate.add(1, 'day');
                    }
                    
                    // Update the task if the date was adjusted
                    if (!adjustedDueDate.isSame(moment(this.task.dueAt), 'day')) {
                        const officeTimezone = this.allSettings?.GENERAL_TIMEZONE?.PropertyValue || 'America/New_York';
                        const dateFormat = officeTimezone.toUpperCase() === 'AFRICA/MASERU' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
                        
                        // Update the task object reactively
                        Vue.set(this.task, 'dueAt', adjustedDueDate.toDate());
                        Vue.set(this.task, 'dueAtStr', adjustedDueDate.format(dateFormat));
                        
                        console.log(`Due date immediately adjusted from ${originalDate} to ${this.task.dueAtStr} to skip excluded day(s)`);
                        
                        // Also trigger the repeat change to ensure consistency
                        this.onRepeatChange(this.task);
                    }
                }
            }
        },

        formatRepeatFrequency(frequency) {
            if (!frequency) return '';
            if (!this.task) return `Repeats ${frequency.toLowerCase()}`;

            const dayNamesFull = { Sun: 'Sunday', Mon: 'Monday', Tue: 'Tuesday', Wed: 'Wednesday', Thu: 'Thursday', Fri: 'Friday', Sat: 'Saturday' };
            
            switch(frequency) {
                case 'Daily': {
                    let dailyText = 'Repeats daily';
                    const excludedDays = [];
                    if (this.task.excludeSaturday) excludedDays.push('Saturday');
                    if (this.task.excludeSunday) excludedDays.push('Sunday');
                    if (excludedDays.length > 0) {
                        dailyText += ` (excluding ${excludedDays.join(' and ')})`;
                    }
                    return dailyText;
                }
                case 'Weekly': 
                    return this.task.repeatOn && dayNamesFull[this.task.repeatOn] ? `Repeats weekly on ${dayNamesFull[this.task.repeatOn]}` : 'Repeats weekly';
                case 'Bi-Weekly': 
                    return this.task.repeatOn && dayNamesFull[this.task.repeatOn] ? `Repeats bi-weekly on ${dayNamesFull[this.task.repeatOn]}` : 'Repeats bi-weekly';
                case 'Monthly':
                    if (this.task.repeatOnLastDayOfMonth === true) {
                        return 'Repeats last day of every month';
                    } 
                    return this.task.repeatOnDay ? `Repeats ${this.getOrdinal(this.task.repeatOnDay)} of every month` : 'Repeats monthly';
                case 'Yearly': 
                    if (this.task.repeatOnDay && this.task.repeatOnMonth) {
                        const monthName = this.fullMonths[this.task.repeatOnMonth - 1] || `Month ${this.task.repeatOnMonth}`;
                        // Check for last day of month setting for yearly tasks too
                        if (this.task.repeatOnLastDayOfMonth === true) {
                             return `Repeats last day of ${monthName} every year`;
                        } 
                        return `Repeats every ${monthName} ${this.getOrdinal(this.task.repeatOnDay)}`;
                    }
                    return 'Repeats yearly';
                default: 
                    return `Repeats ${frequency.toLowerCase()}`; // Fallback for any other case
            }
        },

        getInitials(name) {
            if (!name) return '';
            
            const parts = name.split(' ');
            if (parts.length === 1) return parts[0].charAt(0);
            
            return parts[0].charAt(0) + parts[parts.length - 1].charAt(0);
        },

        getPersonAvatar(person) {
            if (this.employees) {
                const employee = this.employees.find(e => e.EmployeeID === person);
                // Check for valid PictureUrl - must exist, not be "null" string, and not be empty
                if (employee && employee.PictureUrl && 
                    employee.PictureUrl !== 'null' && 
                    employee.PictureUrl !== 'undefined' &&
                    employee.PictureUrl.trim() !== '') {
                    return employee.PictureUrl;
                }
            }
            return null;
        },

        getAvatarClass(person) {        
            if (this.getPersonAvatar(person)) {
                return '';
            }
            
            if (!person) return 'bg-gray-200 text-gray-700';
            
            let hash = 0;
            for (let i = 0; i < person.length; i++) {
                hash = person.charCodeAt(i) + ((hash << 5) - hash);
            }
            
            const colorIndex = Math.abs(hash) % this.avatarColors.length;
            return this.avatarColors[colorIndex];
        },

        async init() {
            if(this.task) {
                // console.log("Initializing TodoDetails with task:", this.task);
                // console.log('TodoDetails init - task.repeatOnLastDayOfMonth:', this.task?.repeatOnLastDayOfMonth);
                
                // Reset pagination
                this.currentPage = 1;

                if(this.task.repeatOnLastDayOfMonth)
                    this.isDayOfMonthDisabled = true;
                
                // CRITICAL FIX: Initialize exclude day properties for Vue reactivity
                if (this.task.excludeSaturday === undefined) {
                    Vue.set(this.task, 'excludeSaturday', false);
                }
                if (this.task.excludeSunday === undefined) {
                    Vue.set(this.task, 'excludeSunday', false);
                }
                
                // *** ADDED: Initialize selectedAssigneesForEdit ***
                if (this.task.assignees && this.activeEmployees) {
                    this.selectedAssigneesForEdit = this.activeEmployees.filter(emp => 
                        this.task.assignees.includes(emp.EmployeeID)
                    );
                    // console.log('Initialized selectedAssigneesForEdit:', this.selectedAssigneesForEdit);
                } else {
                    this.selectedAssigneesForEdit = [];
                }
                // *** END ADDITION ***
                
                // *** ADDED: Initialize subtasks from task ***
                if (this.task.subtasks && Array.isArray(this.task.subtasks)) {
                    // Deep copy to avoid mutating the prop directly
                    this.subtasks = this.task.subtasks.map(st => ({
                        ...st,
                        // Ensure dates are properly converted if stored as Firestore timestamps
                        createdAt: st.createdAt?.toDate ? st.createdAt.toDate() : st.createdAt,
                        completedAt: st.completedAt?.toDate ? st.completedAt.toDate() : st.completedAt
                    }));
                    // console.log('Initialized subtasks:', this.subtasks);
                } else {
                    this.subtasks = [];
                }
                this.newSubtaskContent = ''; // Reset input
                // *** END ADDITION ***

                // Initialization moved to task.tags watcher

                // Process wiki pages if they exist
                if (this.task.wikiPages && this.wikiPages && this.wikiPages.length > 0) {
                    // Convert task.wikiPages to array if it's a string
                    const taskWikiPageIds = Array.isArray(this.task.wikiPages) 
                        ? this.task.wikiPages 
                        : (typeof this.task.wikiPages === 'string' ? [this.task.wikiPages] : []);
                    
                    // console.log("Task wiki page IDs:", taskWikiPageIds);
                    
                    // Find matching wiki pages
                    this.selectedWikiPages = this.wikiPages.filter(page => {
                        return taskWikiPageIds.some(id => {
                            // Convert both to strings for comparison to handle different data types
                            return String(page.WikiPageID) === String(id);
                        });
                    });
                    
                    // console.log("Initialized selectedWikiPages:", this.selectedWikiPages);
                } else {
                    //console.log("No wiki pages in task or no available wiki pages");
                    this.selectedWikiPages = [];
                }
                
                if(this.task.unreadCommentsList && this.task.unreadCommentsList.indexOf(this.userID) > -1) {
                    // Lets remove this person from the commentsUnreadList
                    let task = {
                        id: this.task.id,
                        unreadCommentsList: this.task.unreadCommentsList.filter(a => a !== this.userID),
                        siteID: this.task.siteID,
                        status: this.task.status,                                       
                        content: this.task.content,
                        createdByEmpID: this.task.createdByEmpID,                        
                        assignedToEmpID: this.task.assignedToEmpID ? this.task.assignedToEmpID : this.userID,
                        assignees: this.task.assignees,
                        deleted: this.task.deleted || false,
                        ...(this.task.taggedPatients && this.task.taggedPatients.length > 0 && {taggedPatients: this.task.taggedPatients}),
                        ...(this.task.completedByEmpID && { completedByEmpID : this.task.completedByEmpID }),
                        ...(this.task.createdAt && { createdAt: moment(this.task.createdAt).toDate() }),
                        ...(this.task.completedAt && { completedAt: moment(this.task.completedAt).toDate() }),
                        ...(this.task.completedAt && { completedAtStr: moment(this.task.completedAt).format('MM/DD/YYYY')}),
                        ...(this.task.dueAt && { dueAt: moment(this.task.dueAt).toDate() }),
                        ...(this.task.dueAt && { dueAtStr: moment(this.task.dueAt).format('MM/DD/YYYY') }),
                        ...(this.task.sortID && { sortID: this.task.sortID }),
                        ...(this.task.timestamp && { timestamp: this.task.timestamp }),
                        ...(this.task.timezone && { timezone: this.task.timezone }),
                        ...(this.selectedWikiPages.length > 0 && { wikiPages: _.map(this.selectedWikiPages, 'WikiPageID') }),
                        ...(this.task.repeat && this.task.repeatFrequency && { repeat: this.task.repeat }),
                        ...(this.task.repeatFrequency && { repeatFrequency: this.task.repeatFrequency }),
                        ...(this.task.repeatOn && { repeatOn: this.task.repeatOn }),
                        ...(this.task.repeatOnDay && { repeatOnDay: this.task.repeatOnDay }),
                        ...(this.task.repeatOnMonth && { repeatOnMonth: this.task.repeatOnMonth }),
                        ...(this.task.repeatOnLastDayOfMonth && { repeatOnLastDayOfMonth: this.task.repeatOnLastDayOfMonth }),
                        ...(this.task.excludeSaturday !== undefined && { excludeSaturday: this.task.excludeSaturday }),
                        ...(this.task.excludeSunday !== undefined && { excludeSunday: this.task.excludeSunday })
                    };

                    // console.log(`updating task: ${JSON.stringify(task)}`);
                    await this.updateTask(task);
                }
                
                // *** MODIFIED: Set initial wiki collapse state based on attachments ***
                // Check if selectedWikiPages has items AFTER the watcher (with immediate: true) potentially runs
                this.$nextTick(() => { // Use nextTick to ensure watcher has run
                    Vue.set(this.isShown, 2, this.selectedWikiPages && this.selectedWikiPages.length > 0);
                    // console.log(`Initial wiki section visibility set to: ${this.isShown[2]}`);
                });
                // Ensure comments stay open initially
                Vue.set(this.isShown, 4, true);
                // *** END MODIFICATION ***
                
                this.originalAssigneeID = this.task.assignedToEmpID;
                this.originalAssignees = this.task.assignees;
            } else {
                this.setErrored2(true);
                this.setMessage2('Something went wrong. The task you are trying to access may not be available. Please close this and try refreshing the tasks page');
                return;
            }
        },

        toggleBlock(index) {
            //console.log(`index: ${index}`);
            Vue.set(this.isShown, index, !this.isShown[index]);
        },

        /*
            If the user changes who the task is assigned to then check who the new assignee is and replace tag with him.
            However, if the new assignee is the same as current user then just go ahead and remove the whole tag as we don't need to show tag for the logged in user
            We only show assignee tags when the task is assigned to someone other than the user himself
        */

       /*
        updateAssignedEmployeeTagInContent1(e) {
            console.log(`update assigned empoyee tag called. Event: ${JSON.stringify(e)}`);
            console.log(`task: ${JSON.stringify(this.task)}`);
            let regex = /<span.*data-teamio-employeeid.*<\/span>/gm;
            let originalAssignee = this.getEmployee(this.originalAssigneeID);
            let replaceWith = e.EmployeeID !== this.originalAssigneeID ? `<span data-at-embedded="" contenteditable="false"> <span class="badge mr-xs badge-primary badge-pill mt-1" data-teamio-employeeid="${e.EmployeeID}">${e.Name}</span></span>` 
                                                                    : `<span data-at-embedded="" contenteditable="false"> <span class="badge mr-xs badge-primary badge-pill mt-1" data-teamio-employeeid="${originalAssignee.EmployeeID}">${originalAssignee.Name}</span></span>` 
                                                                    
            Vue.set(this.task, 'content', this.task.content.replace(regex, replaceWith));
        },
        */

        updateAssignedEmployeeTagInContent(e) {            
            console.log(`update assigned empoyee tag called. Event: ${JSON.stringify(e)}`);
            console.log(`task: ${JSON.stringify(this.task)}`);

            let regex = /data-teamio-employeeid="([a-zA-z0-9\-]+)\"\>(.*?)\<\/span\>/g;
            let originalAssignee = this.getEmployee(this.originalAssigneeID);
            let temp = this.task.content.match(regex);            

            let assignees = [];        
            let match;

            console.log('content', this.task.content);
            console.log('assignees', this.task.assignees);

            while(match = regex.exec(this.task.content)) {
                console.log('match', match);                
            }  

            /*
            if(temp && temp.length > 0) {
                let employeeIDToReplace = temp[1];
                let employeeNameToReplace = temp[2];
                if(e.EmployeeID !== this.originalAssigneeID) {
                    Vue.set(this.task, 'content', this.task.content.replace(employeeIDToReplace, e.EmployeeID));
                    Vue.set(this.task, 'content', this.task.content.replace(employeeNameToReplace, e.Name));
                } else {
                    Vue.set(this.task, 'content', this.task.content.replace(employeeIDToReplace, originalAssignee.EmployeeID));
                    Vue.set(this.task, 'content', this.task.content.replace(employeeNameToReplace, originalAssignee.Name));
                }
            }*/
        },

        getLinkedEmployeeID(content) {
            let regex = /data-teamio-employeeid="([a-zA-z0-9\-]+).*?/g;
            let result = regex.exec(content);
            let result1 = content.match(regex);
            //console.dir(result1);
            //console.log(`result1: ${JSON.stringify(result1, null, ' ')}`);
            /*
            if(result1 && result1.length > 1) {
            // User has @mentioned multiple people. Warn them that they can only assign the task to 1 person
            throw new Error("You tried to assign the task to more than one person. You can only @mention at max one person");
            }*/
            if(result) {
                //console.log(`result: ${JSON.stringify(result, null, ' ')}`);
                return result[1];
            } else
                return null;
        },

        getAllLinkedEmployeeID(content) {
            let regex = /data-teamio-employeeid="([a-zA-z0-9\-]+).*?/g;
            let assignees = [];        
            let match;
            while(match = regex.exec(content)) {            
                assignees.push(match[1]);
            }        
            return assignees;
        },

        getLinkedWikiPageID(content) {
            let regex = /data-teamio-wikipageid="([a-zA-z0-9\-]+).*/;
            let result = regex.exec(content);
            if(result) {
                //console.log(`regex result: ${result}`);
                return result[1];
            } else
                return null;
        },

        // Delegates to the shared parser in src/utils/taskPatients.js (covered by
        // cypress/node-tests/task-patients.test.js) so the tick-time commlog check and the
        // save-time one provably read the badges the same way. This used to be a hand-rolled
        // duplicate with a non-global regex plus a manual substring walk.
        getTaggedPatientIDs(content) {
            return parseTaggedPatientIDs(content);
        },

        // The patient badges live inside the contenteditable div (ref="newtodo"), so they have to
        // be read from the DOM on demand — a computed over task.content goes stale while editing.
        // Falls back to task.content when the ref isn't mounted yet.
        currentTaggedPatientIDs() {
            const html = (this.$refs && this.$refs.newtodo && this.$refs.newtodo.innerHTML)
                || (this.task && this.task.content)
                || '';
            return parseTaggedPatientIDs(html);
        },

        // Warn the moment the box is ticked, rather than letting the user write a whole comment and
        // only discover at Save Changes that nothing can go to the commlog. The commlog row needs
        // exactly one patient, so anything else reverts the box. Unticking never warns.
        onSaveToCommLogChange(newValue) {
            if (newValue !== 'TRUE') return;

            const tagged = this.currentTaggedPatientIDs();
            if (tagged.length === 1) return;

            this.saveToCommLog = 'FALSE';
            this.$toast.warning(tagged.length === 0
                ? "No patient is tagged on this task, so this comment can't be saved to the commlog. Tag a patient first."
                : "This task has more than one patient tagged. The commlog needs exactly one patient — remove the extra tag first.");
        },

        toggleDatePicker() {
            //console.log(this.openDatePickerPopup[1]);
            //console.log(!this.openDatePickerPopup[1]);
            // console.log(index, this.openDatePickerPopup);
            // console.log('if else',  Object.keys(this.openDatePickerPopup));
            this.openDatePickerPopup[1] = !this.openDatePickerPopup[1];
        },

        clearDate(task) {
            if(!task) return;
            
            if(task.repeat) Vue.delete(task, 'repeat');
            if(task.repeatFrequency) Vue.delete(task, 'repeatFrequency');
            if(task.repeatOn) Vue.delete(task, 'repeatOn');
            if(task.repeatInterval) Vue.delete(task, 'repeatInterval');
            if(task.repeatOnLastDayOfMonth) Vue.delete(task, 'repeatOnLastDayOfMonth');
        },

        repeatDescription(task) {
            if(!task || !task.repeatFrequency) return '';
            
            let desc = `This task repeats ${task.repeatFrequency}`;

            if(task.repeatOn && task.repeatFrequency === 'Weekly' && task.repeatFrequency === 'Bi-Weekly') {
                desc = desc + ` on ${task.repeatOn}`;
            }

            if(task.repeatOnDay && task.repeatFrequency !== 'Daily' && task.repeatFrequency !== 'Weekly' && task.repeatFrequency !== 'Bi-Weekly') {                
                desc = desc + ` on ${task.repeatOnDay}`;
                switch(task.repeatOnDay) {
                    case '1' : desc = `${desc}<sup>st</sup>`; break;
                    case '2' : desc = `${desc}<sup>nd</sup>`; break;
                    case '22' : desc = `${desc}<sup>nd</sup>`; break;
                    case '3' : desc = `${desc}<sup>rd</sup>`; break;
                    case '21' : desc = `${desc}<sup>st</sup>`; break;
                    case '31' : desc = `${desc}<sup>st</sup>`; break;
                    default: desc = `${desc}<sup>th</sup>`; break;
                }
            }

            if(task.repeatOnMonth) {
                desc = desc + ` of ${moment().month(task.repeatOnMonth).format("MMM")}`;
            }

            return desc;
        },

        getNewEmployeesToNotify(originalAssignees, newAssignees) {
            if (!this.arraysEqual(originalAssignees, newAssignees)) {
                //first check if there's at least something in common between what was there before and after
                let intersect = _.intersection(originalAssignees, newAssignees);
                if (intersect.length === 0) {
                // there's nothing in common so we can just take the new value
                return newAssignees;
                } else {
                return _.difference(newAssignees, originalAssignees);
                }
            } else return [];
        },

        async save() {
            try { // Outer try for initial validation checks
                this.overlayshow = !this.overlayshow;
                let content = this.$refs['newtodo'].innerText
                let contentHTML = this.$refs['newtodo'].innerHTML;

                let taggedPatients = this.getTaggedPatientIDs(contentHTML);
                //console.log('taggedPatients', taggedPatients);

                // --- Start Initial Validation Checks ---
                if(!content) {
                    this.overlayshow = false;
                    this.$toast.error("Please enter a task before saving");
                    return;
                }

                if(this.saveToCommLog === 'TRUE' && taggedPatients.length > 1) {
                     this.overlayshow = false;
                    this.$toast.error("You are trying to save the comment to comm log but you have multiple patients tagged. Please remove one before saving or uncheck the save to comm log checkbox");
                    return;
                }

                if(this.saveToCommLog === 'TRUE' && (taggedPatients.length === 0)) {
                     this.overlayshow = false;
                    this.$toast.error("You are trying to save this comment to comm log but you do not have any patient tagged in this task. Please tag a patient or uncheck the option to save to comm log");
                    return;
                }

                if(this.task && this.task.repeat) {
                    if(this.task.repeatFrequency === 'Weekly' && !this.task.repeatOn) {
                        this.overlayshow = false;
                        this.$toast.error("Please select a day for your weekly repeated task before saving");
                        return;
                    } else if (this.task.repeatFrequency === 'Monthly' && !this.task.repeatOnDay && !(this.task.repeatOnLastDayOfMonth === true)) { // Added check for last day
                         this.overlayshow = false;
                        this.$toast.error("Please select a day (or 'Last Day') for your Monthly repeated task before saving");
                        return;
                    } else if (this.task.repeatFrequency === 'Yearly') {
                        if(!this.task.repeatOnDay && !(this.task.repeatOnLastDayOfMonth === true)) { // Added check for last day
                             this.overlayshow = false;
                            this.$toast.error("Please select a Date (or 'Last Day') for your Yearly repeated task before saving");
                            return;
                        } else if(!this.task.repeatOnMonth) {
                             this.overlayshow = false;
                            this.$toast.error("Please select a Month for your Yearly repeated task before saving");
                            return;
                        }
                    }
                }
                // --- End Initial Validation Checks ---

                let assignedToEmpID = this.getLinkedEmployeeID(contentHTML);
                let wikiPageID = this.getLinkedWikiPageID(contentHTML);
                let assignees = this.getAllLinkedEmployeeID(contentHTML);

                if(assignees.length === 0) {
                    if(assignedToEmpID)
                        assignees.push(assignedToEmpID);
                    else
                // console.log('Tags before saving:', JSON.stringify(this.selectedTagsForEdit)); // Log tags right before constructing save payload

                        assignees.push(this.task.assignedToEmpID);
                }

                let createdByEmpID = this.task.createdByEmpID;

                // Prepare the task object
                let task = {
                    id: this.task.id,
                    siteID: this.task.siteID,
                    status: this.task.status || 'INCOMPLETE',
                    content: contentHTML,
                    createdByEmpID: createdByEmpID,
                    // assignedToEmpID: this.task.assignedToEmpID ? this.task.assignedToEmpID : this.userID, // Keep original or remove if not needed for multi-assignee
                    assignees: this.selectedAssigneesForEdit.map(emp => emp.EmployeeID), // <-- Use selected assignees from multiselect
                    tags: [...this.selectedTagsForEdit], // <-- Add selected tags
                    lastActivity: moment().toDate(),
                    deleted: this.task.deleted || false,
                    ...(taggedPatients && taggedPatients.length > 0 && {taggedPatients: taggedPatients}),
                    ...(this.task.completedByEmpID && { completedByEmpID : this.task.completedByEmpID }),
                    ...(this.task.createdAt && { createdAt: moment(this.task.createdAt).toDate() }),
                    ...(this.task.completedAt && { completedAt: moment(this.task.completedAt).toDate() }),
                    ...(this.task.completedAt && { completedAtStr: moment(this.task.completedAt).format('MM/DD/YYYY')}),
                    ...(this.task.dueAt && { dueAt: moment(this.task.dueAt).toDate() }),
                    ...(this.task.dueAt && { dueAtStr: moment(this.task.dueAt).format('MM/DD/YYYY') }),
                    ...(this.task.sortID && { sortID: this.task.sortID }),
                    ...(this.task.timestamp && { timestamp: this.task.timestamp }),
                    ...(this.task.timezone && { timezone: this.task.timezone }),
                    ...(this.selectedWikiPages.length > 0 && { wikiPages: _.map(this.selectedWikiPages, 'WikiPageID') }),
                    ...(this.task.repeat && this.task.repeatFrequency && { repeat: this.task.repeat }),
                    ...(this.task.repeatFrequency && { repeatFrequency: this.task.repeatFrequency }),
                    ...(this.task.repeatOn && { repeatOn: this.task.repeatOn }),
                    ...(this.task.repeatOnDay && { repeatOnDay: this.task.repeatOnDay }),
                    ...(this.task.repeatOnMonth && { repeatOnMonth: this.task.repeatOnMonth }),
                    ...(this.task.repeatOnLastDayOfMonth && { repeatOnLastDayOfMonth: this.task.repeatOnLastDayOfMonth }),
                    ...(this.task.excludeSaturday !== undefined && { excludeSaturday: this.task.excludeSaturday }),
                    ...(this.task.excludeSunday !== undefined && { excludeSunday: this.task.excludeSunday }),
                    // *** ADDED: Include subtasks in save payload ***
                    // Only include subtasks field if:
                    // 1. There are subtasks to save, OR
                    // 2. The task previously had subtasks (need to clear them)
                    ...((this.subtasks && this.subtasks.length > 0) || this.task.subtasks ? {
                        subtasks: this.subtasks && this.subtasks.length > 0 
                            ? this.subtasks.map((st, index) => ({
                                id: st.id && !st.id.startsWith('temp-') ? st.id : this.generateSubtaskId(),
                                content: st.content,
                                status: st.status || 'INCOMPLETE',
                                sortOrder: index,
                                createdAt: st.createdAt || new Date(),
                                ...(st.completedAt && { completedAt: st.completedAt }),
                                ...(st.completedByEmpID && { completedByEmpID: st.completedByEmpID })
                            }))
                            : [] // Clear subtasks if all were deleted
                    } : {})
                };
                
                // *** NEW: Handle due date normalization ***
                if (this.task.dueAt) {
                    const officeTimezone = this.allSettings?.GENERAL_TIMEZONE?.PropertyValue || 'America/New_York';
                    const dateFormat = officeTimezone.toUpperCase() === 'AFRICA/MASERU' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
                    const normalizedDueMoment = moment.tz(this.task.dueAt, officeTimezone).startOf('day');
                    task.dueAt = normalizedDueMoment.toDate();
                    task.dueAtStr = normalizedDueMoment.format(dateFormat);
                }
                // *** END NEW ***

                // *** NEW: Check if due date conflicts with exclude days for recurring tasks ***
                if (this.task.repeat && this.task.repeatFrequency === 'Daily' && this.task.dueAt) {
                    const excludedDays = [];
                    if (this.task.excludeSaturday) excludedDays.push('Saturday');
                    if (this.task.excludeSunday) excludedDays.push('Sunday');
                    
                    if (excludedDays.length > 0) {
                        let adjustedDueDate = moment(task.dueAt);
                        const originalDate = adjustedDueDate.format('MM/DD/YYYY');
                        
                        // Keep advancing the date until we find a non-excluded day
                        while (excludedDays.includes(adjustedDueDate.format('dddd'))) {
                            adjustedDueDate.add(1, 'day');
                        }
                        
                        // Update the task if the date was adjusted
                        if (!adjustedDueDate.isSame(moment(task.dueAt), 'day')) {
                            const officeTimezone = this.allSettings?.GENERAL_TIMEZONE?.PropertyValue || 'America/New_York';
                            const dateFormat = officeTimezone.toUpperCase() === 'AFRICA/MASERU' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
                            task.dueAt = adjustedDueDate.toDate();
                            task.dueAtStr = adjustedDueDate.format(dateFormat);
                            console.log(`Due date adjusted from ${originalDate} to ${task.dueAtStr} to skip excluded day(s)`);
                            
                            // Update the local task object so the UI reflects the change
                            this.task.dueAt = task.dueAt;
                            this.task.dueAtStr = task.dueAtStr;
                        }
                    }
                }
                // *** END NEW ***

                // Prepare notifications (consider simplifying this logic later)
                let notifications = [];
                let newPeopleToNotify = this.getNewEmployeesToNotify(this.originalAssignees, task.assignees);
                for(let people of newPeopleToNotify) {
                    if (people === this.userID) continue; // match ToDo.vue / PracticePulse convention — never ping yourself
                    notifications.push({
                        audience: 'EMPLOYEE',
                        employeeID: people,
                        type: 'TASK',
                        text: `You have been assigned a <a href='/app/todo/#taskID#'>task</a> by ${this.user.Name}`,
                        siteID: this.siteID,
                        createdAt: new Date(),
                        unreadList: [people], // Notify only the new assignee
                        taskID: this.task.id
                    });
                }

                 // *** REVISED SAVE LOGIC ***
                 try { // Outer try for validation checks (if any) and Firestore operations
                     // 1. Update the main task data first
                     const { id, ...taskUpdatePayload } = task; // Extract id, keep the rest for payload
                     // console.log('Attempting to update task. Payload being sent:', taskUpdatePayload); // Log the specific payload
                     await this.updateTask({ id: this.task.id, ...taskUpdatePayload }); // Send ID and the fields to update
                     // console.log('Task update successful.');

                     // 2. If comment exists, add it
                     if (this.commentText !== '') {
                         // Inner try-catch specifically for comment adding and its notifications
                         try {
                             let comment = {
                                 createdAt: moment().toDate(),
                                 siteID: this.task.siteID, // Re-use siteID from task
                                 employeeID: this.userID, // This is the commenterID
                                 createdByEmpName: this.user.Name, // Added for notification text
                                 taskID: this.task.id, 
                                 text: this.commentText,
                                 saveToCommLog: this.saveToCommLog,
                                 taggedPatients: taggedPatients,
                                 defaultDB: this.user.DefaultDB,
                                 userODNum: this.user.ODUserNum
                             };
                             
                             const payload = {
                                comment: comment,
                                assignees: this.task.assignees || [], 
                                taskID: this.task.id,
                                taskContent: this.task.content, 
                                commenterID: this.userID, 
                                siteID: this.task.siteID 
                             };
                             // console.log('Attempting to add comment with payload:', payload);
                             await this.addTaskComment(payload); 
                             // console.log('Comment addition action dispatched successfully.');

                             // Clear comment input ONLY if comment add succeeded
                             this.commentText = '';
                             // Reset the box too, or the next comment in this same panel session
                             // would silently go to the commlog as well.
                             this.saveToCommLog = 'FALSE';

                         } catch (commentError) {
                            // Handle errors specifically from adding the comment/notifications
                            this.overlayshow = false; // Still hide overlay
                            this.$toast.error(commentError.message || "Error adding comment");
                            console.error("Error during comment adding process:", commentError);
                            // Decide if you want to stop the whole save process here or just log
                            // For now, we just log and the rest of the success logic below won't run for comment
                            throw commentError; // Re-throw to prevent further execution in the outer try if needed
                         }
                     } else {
                         // console.log('No new comment text found, skipping comment add.');
                     }

                     // 3. Handle task assignment notifications (if any were prepared earlier).
                     // The store resolves the #taskID# placeholder and writes one doc per new
                     // assignee. It swallows its own errors, so a notification failure can't
                     // undo the task update that already succeeded above.
                     if (notifications.length > 0) {
                          await this.addTaskAssignmentNotifications({ notifications, taskID: this.task.id });
                     }

                     // 4. Overall Success feedback and close (if no errors were thrown)
                     this.overlayshow = false; 
                     this.$toast.success("Task saved successfully!");
                     this.$emit('task-updated', task); // Emit the updated task object
                     this.$emit('closePanel', {});

                 } catch (saveError) { // Catch errors from task update or re-thrown comment errors
                     this.overlayshow = false;
                     this.$toast.error(saveError.message || "Error during save process");
                     console.error("Error during save process:", saveError);
                 }
                 // *** END REVISED SAVE LOGIC ***

            } catch(validationError) { // Catch errors from initial checks
                this.overlayshow = false;
                this.$toast.error(validationError.message || "Validation error before saving");
                console.error("Pre-save validation error:", validationError);
            }
        },

        async toggleTaskStatus() {
            if (this.task.status === 'COMPLETED') {
                // Mark as incomplete
                this.task.status = 'INCOMPLETE';
                delete this.task.completedAt;
                delete this.task.completedAtStr;
                delete this.task.completedByEmpID;
            } else {
                // Mark as complete
                this.task.status = 'COMPLETED';
                this.task.completedAt = moment().toDate();
                this.task.completedAtStr = moment().format('MM/DD/YYYY');
                this.task.completedByEmpID = this.userID;
            }
            await this.save();
        },

        selectLastDayOfMonth() {
            //console.log('in selectLastDayOfMonth', this.task);
            this.isDayOfMonthDisabled = !this.isDayOfMonthDisabled;
            if(this.task.repeatOnLastDayOfMonth)
                this.task.repeatOnLastDayOfMonth = this.task.repeatOnLastDayOfMonth === 'yes' ? 'no' : 'yes';
            else
                this.task.repeatOnLastDayOfMonth = 'yes';            
            this.task.dueAt = this.getDueDate(this.task).toDate(); 
            this.task.repeatOnDay = parseInt(moment(this.task.dueAt).endOf('month').format('DD'));
        },

        importFromGoogle() {
            const panel2Handle = this.$showPanel({
                component : GoogleImport,
                openOn: 'right',
                width: 750,
                props: {
                    
                }
            });

            panel2Handle.promise
            .then(result => {
                //console.log(`panel handle promise done`);
                
            });
        },

        cleanContent(content) {
            if (!content) return { text: '', tags: [], patients: [], employees: [] };
            
            try {
                // Create a temporary div to parse HTML
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = content;
    
                // Initialize result object
                const result = {
                    text: '',
                    employees: [],
                    patients: [],
                    tags: []
                };
    
                // Function to process text nodes
                const processNode = (node) => {
                    if (node.nodeType === Node.TEXT_NODE) {
                        return node.textContent.trim();
                    }
                    
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        // Check if this is a badge
                        if (node.classList.contains('badge')) {
                            if (node.hasAttribute('data-teamio-employeeid')) {
                                const employeeId = node.getAttribute('data-teamio-employeeid');
                                const employeeName = node.textContent.trim();
                                result.employees.push({ id: employeeId, name: employeeName });
                                return '';
                            }
                            if (node.hasAttribute('data-teamio-patientid')) {
                                const patientId = node.getAttribute('data-teamio-patientid');
                                const patientName = node.textContent.trim();
                                result.patients.push({ id: patientId, name: patientName });
                                return '';
                            }
                            // If it's a badge but not an employee or patient, it's a tag
                            const tagText = node.textContent.trim();
                            if (tagText) {
                                result.tags.push(tagText);
                            }
                            return '';
                        }
                        
                        // Process child nodes
                        return Array.from(node.childNodes)
                            .map(processNode)
                            .filter(text => text)
                            .join(' ');
                    }
                    
                    return '';
                };
    
                // Process all nodes and get text content
                result.text = processNode(tempDiv);
                
                // Clean up extra whitespace in text
                result.text = result.text.replace(/\s+/g, ' ').trim();
                
                return result;
            } catch (error) {
                console.error('Error in cleanContent:', error);
                return { text: '', tags: [], patients: [], employees: [] };
            }
        },

        // *** NEW: Ordinal Number Helper ***
        getOrdinal(n) {
            if (n == null) return '';
            const s = ['th', 'st', 'nd', 'rd'];
            const v = n % 100;
            return n + (s[(v - 20) % 10] || s[v] || s[0]);
        },
        // *** END NEW ***

        // Helper to remove repeatOnDay if last day is checked for Monthly
        toggleLastDayOfMonthMonthly(checked) { // Receive the new state
          // Use Vue.set to ensure reactivity if property might not exist initially
          this.$set(this.task, 'repeatOnLastDayOfMonth', checked);
          this.$nextTick(() => {
            if(this.task.repeatOnLastDayOfMonth === true) { 
               Vue.delete(this.task, 'repeatOnDay'); 
            }
          });
        },
        
        // Helper to remove repeatOnDay if last day is checked for Yearly
        toggleLastDayOfMonthYearly(checked) { // Receive the new state
           // Use Vue.set to ensure reactivity
           this.$set(this.task, 'repeatOnLastDayOfMonth', checked);
           this.$nextTick(() => {
            if(this.task.repeatOnLastDayOfMonth === true) {
               Vue.delete(this.task, 'repeatOnDay'); 
            }
          });
        },
        
        // Helper to clear last day flag if month changes in Yearly
        clearLastDayFlagYearly() {
          if(this.task.repeatOnLastDayOfMonth === true) {
              this.task.repeatOnLastDayOfMonth = false; 
          }
        },

        // Method to adjust textarea height based on content
        adjustTextareaHeight() {
          this.$nextTick(() => {
            const el = this.$refs.taskContent;
            if (el) {
              el.style.height = 'auto'; // Reset height to correctly calculate scrollHeight
              el.style.height = `${el.scrollHeight}px`; // Set height to content height
            }
          });
        },

        // *** NEW Method to Copy Task ID ***
        async copyTaskId() {
          if (!this.task || !this.task.id) return;
          try {
            await navigator.clipboard.writeText(this.task.id);
            this.copyIconClass = 'fa-check text-success'; // Change icon to checkmark
            this.$toast.success('Task ID copied to clipboard!', { duration: 2000 });
            setTimeout(() => {
              this.copyIconClass = 'fa-clipboard'; 
            }, 2000);
          } catch (err) {
            console.error('Failed to copy Task ID: ', err);
             this.$toast.error('Failed to copy Task ID.', { duration: 2000 });
          }
        },
        // *** END NEW ***

        // <-- Added Method -->
        setAvatarError(url) {
            if (url) {
                this.$set(this.avatarLoadError, url, true);
            }
        },
    },

    computed: {
        // Demo site (plan Task 6.5): no Google Drive import in the demo practice.
        isDemoSession() {
            return !!this.$store && this.$store.getters['customer/isDemo'] === true;
        },
        // *** Subtask computed properties ***
        completedSubtasksCount() {
            if (!this.subtasks || this.subtasks.length === 0) return 0;
            return this.subtasks.filter(st => st.status === 'COMPLETED').length;
        },
        subtaskProgressPercent() {
            if (!this.subtasks || this.subtasks.length === 0) return 0;
            return Math.round((this.completedSubtasksCount / this.subtasks.length) * 100);
        },
        isCurrentUserCreator() {
            return this.task && this.userID === this.task.createdByEmpID;
        },
        // *** END Subtask computed properties ***
        
        computedAvailableTags() {
          // The options list should be the same as the main input dropdown:
          // all unique tags used across tasks, passed via the siteTags prop.
          // The v-model (selectedTagsForEdit) handles which ones are selected.
          const availableSiteTags = this.siteTags || []; // Prop contains clean strings from ToDo.vue's computed prop
          
          // Ensure it's always an array of strings and sorted
          return availableSiteTags.filter(tag => typeof tag === 'string').sort();
        },

        ...mapState({
            patients: state => state.customer.patients,
        }),

        ...mapGetters({
            'getDueDate' : 'tasks/getDueDate',
            'getEmployee': 'customer/getEmployee'
        }),

        taskAssignedTo: {
            get: function() {
                if (!this.employees || !this.task || !this.task.assignedToEmpID) {
                    return null;
                }
                
                try {
                    const employee = this.employees.filter(e => e.EmployeeID === this.task.assignedToEmpID)[0];
                    return employee || null;
                } catch (error) {
                    console.error('Error in taskAssignedTo:', error);
                    return null;
                }
            },

            set: function(newValue) {
                if (newValue && newValue.EmployeeID) {
                    this.task.assignedToEmpID = newValue.EmployeeID;
                }
            }
        },

        taskAssignees: {
            get: function() {
                if (!this.employees || !this.task || !this.task.assignees) {
                    return [];
                }
                
                try {
                    return this.employees.filter(e => this.task.assignees.includes(e.EmployeeID)) || [];
                } catch (error) {
                    console.error('Error in taskAssignees:', error);
                    return [];
                }
            },
            set: function(newValue) {
                console.log('in set newValue', newValue);
                if (Array.isArray(newValue)) {
                    this.task.assignees = _.map(newValue, 'EmployeeID');
                }
            }
        },

        isCurrentUserCreator() {
            // // *** Logging for debugging ***
            // console.log('Checking isCurrentUserCreator:');
            // console.log(` -> Logged in userID: ${this.userID} (Type: ${typeof this.userID})`);
            // console.log(` -> Task createdByEmpID: ${this.task?.createdByEmpID} (Type: ${typeof this.task?.createdByEmpID})`);
            const isCreator = this.task && this.userID === this.task.createdByEmpID;
            // console.log(` -> isCreator result: ${isCreator}`);
            // *** END LOGGING ***
            return isCreator;
        },


        taskCreatedBy: {
            get: function() {
                if (!this.employees || !this.task || !this.task.createdByEmpID) {
                    return null;
                }
                
                try {
                    const employee = this.employees.filter(e => e.EmployeeID === this.task.createdByEmpID)[0];
                    return employee || null;
                } catch (error) {
                    console.error('Error in taskCreatedBy:', error);
                    return null;
                }
            },
        },

        taskCompletedBy: {
            get: function() {
                if (!this.employees || !this.task || !this.task.completedByEmpID) {
                    return null;
                }
                
                try {
                    const employee = this.employees.filter(e => e.EmployeeID === this.task.completedByEmpID)[0];
                    return employee || null;
                } catch (error) {
                    console.error('Error in taskCompletedBy:', error);
                    return null;
                }
            },
        },

        lastCommentMadeByEmployeeID() {
            if(this.task && this.task.comments) {
                return this.task.comments[this.task.comments.length - 1].employeeID;
            }
        },

        paginatedComments() {
            if (!this.task || !this.task.comments) return [];
            
            const start = (this.currentPage - 1) * this.commentsPerPage;
            const end = start + this.commentsPerPage;
            
            // Sort comments by date descending (newest first)
            const sortedComments = [...this.task.comments].sort((a, b) => {
                return new Date(b.createdAt) - new Date(a.createdAt);
            });
            
            return sortedComments.slice(start, end);
        },

        totalPages() {
            if (!this.task || !this.task.comments) return 1;
            
            return Math.ceil(this.task.comments.length / this.commentsPerPage);
        },

        computedRepeatOnDay: {
            get() {
                // Return the repeatOnDay value if it exists, otherwise return null
                // This ensures the select shows as unselected when no value is set
                return this.task && this.task.repeatOnDay ? parseInt(this.task.repeatOnDay) : null;
            },
            set(value) {
                if (this.task) {
                    // Ensure we're setting a number or null
                    this.task.repeatOnDay = value ? parseInt(value) : null;
                }
            }
        },
        
        computedRepeatOnMonth: {
            get() {
                return this.task ? parseInt(this.task.repeatOnMonth) : 1;
            },
            set(value) {
                if (this.task) {
                    this.task.repeatOnMonth = parseInt(value);
                }
            }
        },

        taskPatients() {
            if (!this.task || !this.task.content) return [];
            try {
                return this.cleanContent(this.task.content).patients;
            } catch (error) {
                console.error('Error in taskPatients:', error);
                return [];
            }
        },

        taskTags() {
            if (!this.task || !this.task.content) return [];
            try {
                return this.cleanContent(this.task.content).tags;
            } catch (error) {
                console.error('Error in taskTags:', error);
                return [];
            }
        },

        ...mapGetters({
            'siteID': 'customer/siteID',
            'userID': 'customer/userID',
            'tasks': 'tasks/tasks',
            'userSettings': 'customer/userSettings',
            'activeTeamIDs': 'customer/activeTeamIDs'
            // Removed mapGetters for non-existent 'availableTags'
            // Remove wikiPages from here as it's being passed as a prop
        }),
        ...mapState({
            'navigationHistory': state => state.navigationHistory,
            'employees': state => state.customer.employees
        }),

        disabledDates() {
            // Return a configuration object for disabled dates
            return {
                // Example of disabled date configurations (uncomment as needed):
                // to: new Date(new Date().setDate(new Date().getDate() - 1)), // Disable all dates before today
                // from: new Date(2023, 11, 31), // Disable all dates after Dec 31, 2023
                // days: [0, 6], // Disable weekends (0 = Sunday, 6 = Saturday)
                // daysOfMonth: [31], // Disable the 31st of each month
                // dates: [new Date(2023, 0, 1)], // Disable specific dates
            };
        },

        activeEmployees() {
            if (!this.employees) return [];
            
            try {
                return this.employees.filter(e => e.Active === 1 || e.Active === '1');
            } catch (error) {
                console.error('Error in activeEmployees:', error);
                return [];
            }
        },

        // *** NEW: Status Computed Properties ***
        isCompletedTask() {
          return this.task && this.task.status === 'COMPLETED';
        },

        isOverdue() {
          // Only overdue if task exists, not completed, and due date is in the past
          return this.task && !this.isCompletedTask && this.task.dueAt && moment(this.task.dueAt).isBefore(moment(), 'day');
        },
        // *** END NEW ***
    },

    watch: {
        task: {
            handler(newTask) {
                if (newTask) {
                    // console.log('Task prop watcher triggered, calling init()');
                    this.init();
                }
            },
            immediate: true // Run handler immediately when component is created/prop first set
        },
        // Add watcher for wikiPages prop
        wikiPages: {
            handler(newVal, oldVal) {
                // console.log('wikiPages prop changed, re-initializing selectedWikiPages.');
                // Re-run initialization logic when wikiPages prop changes
                if (this.task && newVal && newVal.length > 0) {
                    // Process wiki pages if they exist
                    if (this.task.wikiPages) {
                        const taskWikiPageIds = Array.isArray(this.task.wikiPages)
                            ? this.task.wikiPages
                            : (typeof this.task.wikiPages === 'string' ? [this.task.wikiPages] : []);

                        this.selectedWikiPages = newVal.filter(page => {
                            return taskWikiPageIds.some(id => {
                                return String(page.WikiPageID) === String(id);
                            });
                        });
                         // console.log("Watcher updated selectedWikiPages:", this.selectedWikiPages);
                    } else {
                         this.selectedWikiPages = [];
                    }
                } else {
                    this.selectedWikiPages = [];
                }
            },
            immediate: true // Run handler immediately when component is created
        },
        'task.tags': {
            handler(newTags, oldTags) {
                const currentSelection = this.selectedTagsForEdit || [];
                let tagsToSet = [];

                if (Array.isArray(newTags)) {
                    // console.log('task.tags watcher triggered. New tags:', JSON.stringify(newTags));
                    tagsToSet = [...newTags];
                } else {
                    // Handle cases where tags might be null or undefined
                    // console.log('task.tags watcher triggered. Tags are not an array:', newTags);
                    tagsToSet = [];
                }

                // Only update if the tags have actually changed to prevent potential loops
                // Only update if the tags have actually changed to prevent potential loops
                // Compare sorted arrays to ignore order differences
                if (JSON.stringify(tagsToSet.sort()) !== JSON.stringify(currentSelection.sort())) {
                    // console.log('Updating selectedTagsForEdit from', JSON.stringify(currentSelection), 'to', JSON.stringify(tagsToSet));
                    this.selectedTagsForEdit = tagsToSet;
                } else {
                     // console.log('No change detected in tags. Skipping update.');
                }
            },
            immediate: true, // Run immediately to catch initial value
            deep: true // Watch for nested changes within the task object
        },

        'task.repeat' : function (newValue, oldValue) {
            //console.log('task.repeat changed');
            this.task.dueAt = this.getDueDate(this.task).toDate();
        },
        'task.repeatFrequency' : function (newValue, oldValue) {
            //console.log('task.repeatFrequency changed');
            if(newValue === 'Daily')
                this.task.dueAt = this.getDueDate(this.task).toDate();
        },
        'task.repeatOn' : function (newValue, oldValue) {
            //console.log('task.repeatOn changed');
            this.task.dueAt = this.getDueDate(this.task).toDate();
        },
        'task.repeatOnDay' : function (newValue, oldValue) {
            //console.log('task.repeatOnDay changed');
            this.task.dueAt = this.getDueDate(this.task).toDate();
        },
        'task.repeatOnMonth' : function (newValue, oldValue) {
            //console.log('task.repeatOnMonth changed');
            this.task.dueAt = this.getDueDate(this.task).toDate();
        }
    },
}

</script>

<style scoped lang="scss">
/* Add styles for the tag input in details */
.tag-input-details {
  min-height: 38px;
  width: 100%; /* Make it full width in details view */
}

/* Reuse Multiselect customization from ToDo.vue if applicable, or add specific overrides */
.tag-input-details ::v-deep .multiselect__tags {
  min-height: 38px;
  padding: 5px 40px 0 8px;
  border: 1px solid #cbd5e1; /* Match border style */
  border-radius: 4px;
}

.tag-input-details ::v-deep .multiselect__tag {
  background: #3abf94; /* Match tag color */
  color: white;
  margin-bottom: 3px;
}

.tag-input-details ::v-deep .multiselect__tag-icon:after {
  color: white;
}

.tag-input-details ::v-deep .multiselect__tag-icon:focus,
.tag-input-details ::v-deep .multiselect__tag-icon:hover {
  background: #2d9474; /* Darker green on hover */
}

.tag-input-details ::v-deep .multiselect__input {
  background: transparent;
  margin-bottom: 4px;
}

.tag-input-details ::v-deep .multiselect--active {
  z-index: 1000; /* Ensure dropdown is on top */
}
/* End tag input styles */

.TodoDetails {
  font-family: 'Inter', 'Segoe UI', Roboto, -apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif;
  color: #334155;
  background-color: #f8fafc;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.task-details-section {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1rem;
}

.details-header {
  margin-bottom: 0.875rem;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 0.75rem;
  display: flex; /* Added */
  justify-content: space-between; /* Added */
  align-items: center; /* Added */
}

.details-title {
  font-size: 1.15rem;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
}

.task-details-main {
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  margin-bottom: 1rem;
  padding: 1rem;
}

.task-details-main-item {
  margin-bottom: 0.5rem;
  
  &:not(:first-child) {
    padding-top: 0.5rem;
  }
}

.todocontent {
  width: 100%;
  min-height: 100px;
  padding: 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  font-size: 0.9375rem;
  line-height: 1.5;
  margin-bottom: 0.75rem;
  background-color: white;
  transition: border-color 0.15s ease-in-out;
  
  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  }
}

.detail-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 0.375rem;
}

.detail-label {
  width: 110px;
  font-weight: 600;
  color: #475569;
  font-size: 0.875rem;
}

.detail-value {
  flex: 1;
  min-width: 0;
  font-size: 0.9375rem;
}

.badge-assignee {
  background-color: #3b82f6;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  margin-right: 0.5rem;
  font-weight: 500;
  white-space: nowrap;
}

.due-date {
  background-color: #f1f5f9;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  color: #334155;
  font-weight: 500;
  font-size: 0.875rem;
}

.completed-date {
  background-color: #dcfce7;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  color: #166534;
  font-weight: 500;
  font-size: 0.875rem;
}

.date-value {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.repeat-descr {
  font-size: 0.8125rem;
  color: #64748b;
  display: flex;
  align-items: center;
}

.date-picker-container {
  margin-top: 0.75rem;
  border-top: 1px solid #e5e7eb;
  padding-top: 0.75rem;
}

.due-date-popover {
  width: 100%;
}

.date-picker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.date-picker-title {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #475569;
  margin: 0;
}

.date-picker-layout {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.repeat-options {
  flex: 1;
  min-width: 240px;
  transition: all 0.2s ease;
  position: relative;
  z-index: 1100; /* Ensure repeat dropdowns are above bot widget */
}

.repeat-link {
  display: inline-flex;
  align-items: center;
  color: #3b82f6;
  font-weight: 500;
  text-decoration: none;
  font-size: 0.875rem;
  
  &:hover {
    color: #2563eb;
  }
  
  i {
    margin-right: 0.25rem;
    font-size: 0.8125rem;
  }
}

.repeat-form {
  background-color: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  padding: 0.75rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  margin-top: 0.5rem;
  overflow: visible;
  position: relative;
}

.repeat-frequency {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  
  label {
    font-weight: 500;
    font-size: 0.875rem;
    margin: 0;
    color: #475569;
    min-width: 50px;
  }
}

.repeat-select-fixed {
  width: 100%;
  padding: 0.5rem 2rem 0.5rem 0.75rem;
  border: 1px solid #ccc;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  color: #334155;
  background-color: white;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1rem 1rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  text-align: left;
  text-indent: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: visible;
  min-height: 38px; /* Ensure consistent height */
  line-height: 1.5; /* Improve text alignment */
  
  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  }

  &:disabled {
    background-color: #f1f5f9;
    color: #94a3b8;
    cursor: not-allowed;
  }
}

.daily-options,
.weekly-options,
.monthly-options,
.yearly-options {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px dashed #e2e8f0;
  width: 100%;
}

.exclude-days {
  margin-top: 0.5rem;
  width: 100%;
  overflow: visible;
  position: relative;
}

.exclude-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #475569;
  margin-bottom: 0.5rem;
}

.exclude-checkboxes {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  position: relative;
  overflow: visible;
}


.days-of-week {
  margin-top: 0.5rem;
  width: 100%;
}

.days-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #475569;
  margin-bottom: 0.5rem;
}

.day-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
  width: 100%;
}

.day-select-group {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-bottom: 0.75rem;
  width: 100%;
  
  .btn-outline-secondary {
    color: #475569;
    border-color: #cbd5e1;
    background-color: white;
    font-size: 0.75rem;
    padding: 0.25rem 0;
    border-radius: 0.25rem;
    
    &:hover {
      background-color: #f1f5f9;
      border-color: #94a3b8;
    }
    
    &:focus {
      box-shadow: 0 0 0 0.2rem rgba(59, 130, 246, 0.25);
    }
    
    &.active {
      background-color: #3b82f6;
      border-color: #3b82f6;
      color: white;
    }
  }
}

.monthly-day-select,
.yearly-day-select {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  font-size: 0.875rem;

  label {
    font-weight: 500;
    margin: 0;
    color: #475569;
    min-width: 30px;
  }

  span {
    color: #475569;
  }

  .day-label {
    margin-left: 4px;
  }

  sup {
    color: #64748b;
  }
}

.last-day-option {
  font-size: 0.875rem;
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-top: 0.5rem;
  width: 100%;
  display: flex;
  box-sizing: border-box;
}
  
.last-day-checkbox-container {
  flex: 1;
  min-width: 0;
  max-width: calc(100% - 2rem);
  padding: 0 15px 0 20px;
  margin: 5px 0;
  width: 100%;
}

.padded-checkbox {
  margin-left: 15px !important;
  padding: 5px 0 !important;
}

/* Restore original date container styles */
.modal-date {
  width: 265px;
  margin: 0 auto 10px auto;
  text-align: center;
}

::v-deep .vdp-datepicker__calendar {
  width: 265px !important;
  border: 1px solid #e7e7e7;
  border-radius: 4px;
  padding: 6px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.custom-control {
  margin-bottom: 0;
  padding-left: 1.75rem; /* Increase padding to ensure checkbox is visible */
}

.custom-control-label {
  color: #475569;
  padding-top: 0.125rem;
  width: 100%;
  white-space: normal;
  line-height: 1.4;
  
  &::before, &::after {
    top: 0.25rem;
    left: -1.5rem;
  }
}

.info-icon {
  font-size: 0.875rem;
  cursor: help;
  color: #64748b;
  opacity: 0.8;
  
  &:hover {
    opacity: 1;
    color: #3b82f6;
  }
}

.last-day-checkbox-container {
  padding: 0 15px 0 20px;
  margin: 5px 0;
  width: 100%;
}

.custom-control-label {
  padding-left: 5px;
}

.last-day-option {
  margin-top: 10px;
  padding: 8px 0;
  width: 100%;
  display: flex;
}

/* Custom checkbox styling */
::v-deep .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #3b82f6;
  border-color: #3b82f6;
}

::v-deep .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e");
  background-position: center;
  background-size: 50% 50%;
}

.task-details-item {
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  margin-bottom: 0.75rem;
  overflow: visible !important;
  position: relative;
}

.task-details-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e5e7eb;
  background-color: #f8fafc;
}

.section-title {
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #0f172a;
  display: flex;
  align-items: center;
}

.section-icon {
  margin-right: 0.5rem;
  color: #64748b;
}

.toggle-icon {
  color: #64748b;
  transition: transform 0.2s ease;
  
  &.expanded {
    transform: rotate(180deg);
  }
}

.new-feature-badge {
  display: inline-block;
  background: linear-gradient(135deg, #3b82f6, #6366f1);
  color: white;
  font-size: 0.675rem;
  font-weight: 600;
  padding: 0.2rem 0.6rem;
  border-radius: 0.375rem;
  margin-left: 0.625rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  vertical-align: middle;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.25);
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(59, 130, 246, 0.3);
  }
}

.attachment-panel,
.comments-panel {
  padding: 1rem;
}

.panel-body.attachment-panel {
  overflow: visible !important; /* Override any collapse overflow settings */
  position: relative;
}

.wiki-container {
  width: 100%;
}

.wiki-dropdown-wrapper {
  position: relative;
  z-index: 9999; /* Very high z-index to ensure it's always on top */
}

.no-wiki-message {
  color: #64748b;
  font-size: 0.875rem;
  margin-bottom: 1rem;
  
  a {
    color: #3b82f6;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
}

.wiki-list {
  list-style: none;
  padding: 0;
  margin: 0 0 1rem 0;
}

.wiki-item {
  display: flex;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid #e5e7eb;
  
  &:last-child {
    border-bottom: none;
  }
}

.wiki-icon {
  color: #64748b;
  margin-right: 0.5rem;
}

.comments-container {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.comment-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.comment-item {
  display: flex;
  gap: 0.75rem;
}

.comment-avatar {
  flex-shrink: 0;
}

.avatar-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 600;
  color: white;
  /* background-color handled by getAvatarClass */
  position: relative; /* Ensure positioning context */
  overflow: hidden; /* Ensure image is clipped */
}

.comment-content {
  flex: 1;
  min-width: 0;
  background-color: #f8fafc;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  position: relative;
  
  &:before {
    content: '';
    position: absolute;
    left: -6px;
    top: 12px;
    width: 12px;
    height: 12px;
    background-color: #f8fafc;
    transform: rotate(45deg);
  }
}

.comment-header {
  margin-bottom: 0.25rem;
  display: flex;
  justify-content: space-between;
}

.comment-author {
  font-weight: 600;
  font-size: 0.875rem;
  color: #0f172a;
}

.comment-time {
  font-size: 0.75rem;
  color: #64748b;
}

.comment-text {
  font-size: 0.875rem;
  line-height: 1.5;
  word-break: break-word;
}

.pagination-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
  padding: 0.5rem 0;
}

.pagination-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: #f8fafc;
  border: 1px solid #e5e7eb;
  color: #0f172a;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover:not(:disabled) {
    background-color: #e2e8f0;
    border-color: #cbd5e1;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  i {
    font-size: 0.75rem;
  }
}

.pagination-info {
  margin: 0 0.75rem;
  font-size: 0.875rem;
  color: #64748b;
  font-weight: 500;
}

.new-comment {
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
}

.comment-input-container {
  flex: 1;
  min-width: 0;
}

.comment-input {
  width: 100%;
  min-height: 80px;
  padding: 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  line-height: 1.5;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  }
}

.comment-options {
  margin-top: 0.5rem;
}

.commlog-option {
  font-size: 0.875rem;
}

.details-footer {
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding-top: 1rem;
}

.complete-toggle-button {
  margin-right: auto;
}

.action-button {
  font-weight: 500;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 1rem;
  
  i {
    font-size: 0.875rem;
  }
}

.save-button {
  background-color: #3b82f6;
  border-color: #3b82f6;
  
  &:hover {
    background-color: #2563eb;
    border-color: #2563eb;
  }
}

.cancel-button {
  color: #64748b;
  border-color: #d1d5db;
  
  &:hover {
    color: #334155;
    background-color: #f1f5f9;
  }
}

.month-select {
  min-width: 100px;
}

.info-icon {
  font-size: 0.875rem;
  cursor: help;
  color: #64748b;
  opacity: 0.8;
  
  &:hover {
    opacity: 1;
    color: #3b82f6;
  }
}

::v-deep .vdp-datepicker__calendar .cell.day-header {
  font-weight: 600;
  color: #475569;
}

::v-deep .vdp-datepicker__calendar header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.25rem;

  .prev,
  .next {
    display: inline-block;
    width: 1.5rem;
    height: 1.5rem;
    position: relative;
    
    &:after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      border-style: solid;
      border-width: 0.25rem 0.25rem 0 0;
      height: 0.5rem;
      width: 0.5rem;
      transform: translate(-50%, -50%) rotate(-135deg);
      transition: border-color 0.2s ease;
      border-color: #64748b;
    }
    
    &:hover:after {
      border-color: #3b82f6;
    }
  }
  
  .next:after {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  
  span {
    color: #1e293b;
    font-weight: 600;
  }
}

::v-deep .vdp-datepicker__calendar .up:after {
  border-color: #64748b;
}

::v-deep .vdp-datepicker__calendar .up:hover:after {
  border-color: #3b82f6;
}

::v-deep .vdp-datepicker__calendar .disabled {
  color: #cbd5e1;
}

/* Responsive styles */
@media (max-width: 768px) {
  .date-picker-layout {
    flex-direction: column;
  }
  
  .repeat-options {
    width: 100%;
  }
  
  .monthly-day-select,
  .yearly-day-select {
    flex-direction: column;
    align-items: flex-start;
    
    label {
      margin-bottom: 0.25rem;
    }
  }
  
  .detail-row {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .detail-label {
    width: 100%;
    margin-bottom: 0.375rem;
  }
  
  .detail-value {
    width: 100%;
  }
}

@media (max-width: 576px) {
  .task-details-section {
    padding: 0.75rem;
  }
  
  .details-footer {
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .action-button {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .day-select-group {
    justify-content: space-between;
    
    .btn-outline-secondary {
      flex: 0 0 calc(14.28% - 0.25rem);
      padding: 0.25rem 0;
      font-size: 0.75rem;
    }
  }
}

.modern-assignees-container {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.assignee-avatars {
  display: flex;
  align-items: center;
  flex-direction: row-reverse; /* Stack avatars left-to-right */
}

.avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.7rem;
  color: white;
  background-color: #3b82f6;
  border: 1.5px solid white;
  background-size: cover;
  background-position: center;
  margin-left: -0.5rem; /* Overlap avatars */
  position: relative; /* Added for positioning context */
  overflow: hidden; /* Added to clip img */
}

.avatar:first-child {
  margin-left: 0;
}

.assignee-names {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.assignee-name {
  font-size: 0.875rem;
  color: #334155;
  line-height: 1.25;
}

.assignee-count {
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 500;
  margin-top: 0.125rem;
}

.modern-patients-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.patient-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.patient-tag {
  display: inline-flex;
  align-items: center;
  background-color: #e2e8f0;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  color: #334155;
  font-weight: 500;
}

.patient-icon {
  color: #64748b;
  margin-right: 0.375rem;
  font-size: 0.875rem;
}

.patient-count {
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 500;
}

.no-patients {
  font-size: 0.875rem;
  color: #94a3b8;
  font-style: italic;
}

.modern-tags-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.tag-item {
  display: inline-flex;
  align-items: center;
  background-color: #f1f5f9;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  color: #475569;
  font-weight: 500;
}

.repeat-tag {
  background-color: #dbeafe;
  color: #2563eb;
}

.no-tags {
  font-size: 0.875rem;
  color: #94a3b8;
  font-style: italic;
}

/* Wiki Multiselect Styles */
.wiki-multiselect {
  margin-top: 0.75rem;
  position: static; /* Override default relative to let our wrapper handle z-index */
}

::v-deep .multiselect__tags {
  min-height: 38px;
  padding: 0.375rem 2rem 0.375rem 0.75rem;
  border-radius: 0.375rem;
  border: 1px solid #e5e7eb;
  background-color: white;
  font-size: 0.875rem;
}

::v-deep .multiselect__select {
  height: 38px;
  width: 38px;
  z-index: 3;
}

::v-deep .multiselect__content-wrapper {
  z-index: 999;
  position: absolute;
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 0 0 0.375rem 0.375rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background: white;
  max-height: 240px !important;
  overflow-y: auto;
}

::v-deep .multiselect__element {
  margin: 0;
  padding: 0;
}

::v-deep .multiselect__option {
  padding: 0.75rem 1rem;
  min-height: 36px;
  line-height: 1.4;
  font-size: 0.875rem;
}

::v-deep .multiselect__tag {
  background-color: #e0f2fe;
  color: #0369a1;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  margin-right: 0.375rem;
  display: flex;
  align-items: center;
  margin-bottom: 0.25rem;
}

::v-deep .multiselect__tag-icon {
  line-height: 1.5;
  margin-left: 0.375rem;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  position: relative;
  
  &:after {
    color: #0369a1;
    font-size: 14px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  
  &:hover {
    background-color: #bae6fd;
    
    &:after {
      color: #0369a1;
    }
  }
}

::v-deep .multiselect__option--highlight {
  background-color: #3b82f6;
  color: white;
  
  &:after {
    background-color: #3b82f6;
    color: white;
  }
}

::v-deep .multiselect__placeholder {
  color: #94a3b8;
  font-size: 0.875rem;
  padding: 0 0.25rem;
}

::v-deep .custom__tag {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.875rem;
  color: #0f172a;
  
  i {
    color: #64748b;
  }
  
  a {
    color: #0f172a;
    text-decoration: none;
    transition: color 0.2s ease;
    
    &:hover {
      color: #3b82f6;
      text-decoration: underline;
    }
  }
}

::v-deep .option__desc {
  display: flex;
  align-items: center;
  margin-left: 0.375rem;
  
  .option__title {
    font-size: 0.875rem;
    color: #334155;
  }
}

/* Wiki Section Styles */
.wiki-container {
  padding: 0.5rem 0;
}

.no-wiki-message {
  color: #64748b;
  font-size: 0.875rem;
  margin-bottom: 1rem;
  
  a {
    color: #3b82f6;
    text-decoration: none;
    font-weight: 600;
    
    &:hover {
      text-decoration: underline;
    }
  }
}

.selected-wikis-container {
  margin-bottom: 1.25rem;
  padding: 0.75rem;
  background-color: #f8fafc;
  border-radius: 0.5rem;
  border: 1px solid #e5e7eb;
}

.selected-wiki-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 0.5rem;
}

.wiki-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.wiki-item {
  display: flex;
  align-items: center;
  padding: 0.375rem 0;
  
  &:not(:last-child) {
    border-bottom: 1px dashed #e2e8f0;
    margin-bottom: 0.375rem;
  }
}

.wiki-icon {
  color: #64748b;
  margin-right: 0.5rem;
  font-size: 0.875rem;
}

.wiki-link {
  color: #3b82f6;
  text-decoration: none;
  font-size: 0.875rem;
  
  &:hover {
    text-decoration: underline;
    color: #2563eb;
  }
}

.wiki-dropdown-section {
  margin-top: 0.5rem;
}

.wiki-dropdown-container {
  position: relative;
}

.wiki-dropdown-label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  color: #475569;
  font-weight: 600;
}

.wiki-multiselect-wrapper {
  position: relative;
  z-index: 9999; /* Very high z-index to ensure it's always on top */
}

/* Vue Multiselect Custom Styling */
::v-deep .multiselect.wiki-multiselect {
  position: static; /* Override default relative to let our wrapper handle z-index */
}

::v-deep .multiselect__tags {
  min-height: 40px;
  padding: 0.5rem 2.5rem 0.5rem 0.75rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.375rem;
  background-color: white;
  font-size: 0.875rem;
}

::v-deep .multiselect__select {
  width: 40px;
  height: 40px;
}

::v-deep .multiselect__placeholder {
  color: #94a3b8;
  padding-top: 0;
  margin-bottom: 0;
}

::v-deep .multiselect__content-wrapper {
  border-radius: 0 0 0.375rem 0.375rem;
  border-color: #cbd5e1;
  background-color: white;
  position: absolute;
  width: 100%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  z-index: 9999; /* Very high z-index */
  max-height: 240px !important; /* Allow scrolling for many options */
}

::v-deep .multiselect__element {
  padding: 0;
}

::v-deep .multiselect__option {
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  min-height: 40px;
  display: flex;
  align-items: center;
}

::v-deep .multiselect__option--highlight {
  background-color: #3b82f6;
  color: white;
  
  &:after {
    background-color: #3b82f6;
  }

  .wiki-option-icon, .wiki-option-name {
    color: white;
  }
}

::v-deep .multiselect__option--selected {
  background-color: #f1f5f9;
  color: #0f172a;
  font-weight: 600;
  
  &.multiselect__option--highlight {
    background-color: #dbeafe;
    color: #2563eb;
    
    .wiki-option-icon, .wiki-option-name {
      color: #2563eb;
    }
  }
}

.wiki-option {
  display: flex;
  align-items: center;
  width: 100%;
}

.wiki-option-icon {
  color: #64748b;
  margin-right: 0.5rem;
  font-size: 0.875rem;
}

.wiki-option-name {
  color: #0f172a;
  font-size: 0.875rem;
}

/* Tags styling */
::v-deep .multiselect__tag {
  background-color: #dbeafe;
  color: #2563eb;
  border-radius: 0.25rem;
  margin-right: 0.5rem;
  margin-bottom: 0.25rem;
  padding: 0.25rem 0.5rem 0.25rem 0.375rem;
  font-size: 0.75rem;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep .multiselect__tag-icon {
  line-height: initial;
  position: relative;
  margin-left: 0.25rem;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background-color: rgba(37, 99, 235, 0.1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  
  &:after {
    color: #2563eb;
    font-size: 0.75rem;
    font-weight: 700;
  }
  
  &:hover {
    background-color: rgba(37, 99, 235, 0.2);
    
    &:after {
      color: #1e40af;
    }
  }
}

// Add these styles to make the calendar look good
.calendar-picker {
  width: 100%;
  margin-bottom: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  overflow: hidden;
}

.calendar-picker >>> .b-form-calendar-grid {
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.calendar-picker >>> .b-calendar-grid-body .btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.calendar-picker >>> .b-calendar-grid-body .btn-light {
  background-color: transparent;
  border-color: transparent;
}

.calendar-picker >>> .b-calendar-grid-body .btn-primary {
  background-color: #3abf94 !important;
  border-color: #3abf94 !important;
  font-weight: bold;
}

.calendar-picker >>> .b-calendar-grid-body .btn:hover:not(.active) {
  background-color: #f1f5f9;
}

.calendar-picker >>> .b-calendar-nav {
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 0.5rem;
  margin-bottom: 0.5rem;
}

.calendar-picker >>> .b-calendar-nav .btn-outline-primary {
  border-color: #e2e8f0;
  color: #3abf94;
}

.calendar-picker >>> .b-calendar-nav .btn-outline-primary:hover {
  background-color: #f8fafc;
  border-color: #3abf94;
  color: #3abf94;
}

.calendar-picker >>> thead {
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #64748b;
}

.calendar-picker >>> .btn-outline-success {
  color: #3abf94;
  border-color: #3abf94;
}

.calendar-picker >>> .btn-outline-success:hover {
  background-color: #3abf94;
  color: white;
}

.date-picker-container {
  margin-bottom: 1.5rem;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.date-picker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f1f5f9;
}

.date-picker-title {
  font-weight: 600;
  color: #334155;
  margin-bottom: 0;
  font-size: 0.9rem;
}

.repeat-link {
  font-size: 0.85rem;
  color: #3abf94;
  font-weight: 500;
  text-decoration: none;
}

.repeat-link:hover {
  text-decoration: underline;
  color: #2c9d78;
}

.date-picker-layout {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.calendar-container {
  width: 100%;
}

.selected-date {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #475569;
  padding: 0.5rem 0;
  margin-top: 0.5rem;
}

.selected-date i {
  color: #3abf94;
}

/* Responsive styles */
@media (max-width: 768px) {
  .date-picker-layout {
    flex-direction: column;
  }
  
  .calendar-container {
    width: 100%;
  }
  
  .calendar-picker >>> .b-calendar-grid-body .btn {
    width: 32px;
    height: 32px;
  }
}

.date-picker-row {
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
  margin-top: 15px;
}

.calendar-container {
  flex: 0 0 auto;
  width: 265px;
  margin-right: 15px;
}

.repeat-options {
  flex: 1;
  min-width: 240px;
  border-left: 1px solid #e5e7eb;
  padding-left: 20px;
}

.modal-date {
  width: 265px;
  margin: 0 auto 10px auto;
  text-align: center;
}

.selected-date {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  font-size: 14px;
  color: #475569;
}

.selected-date i {
  color: #3abf94;
}

::v-deep .vdp-datepicker__calendar {
  width: 265px !important;
  border: 1px solid #e7e7e7;
  border-radius: 4px;
  padding: 6px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

/* Responsive styling */
@media (max-width: 768px) {
  .date-picker-row {
    flex-direction: column;
  }
  
  .calendar-container {
    width: 100%;
    margin-right: 0;
    margin-bottom: 20px;
  }
  
  .repeat-options {
    width: 100%;
    border-left: none;
    padding-left: 0;
    border-top: 1px solid #e5e7eb;
    padding-top: 20px;
  }
  
  .modal-date {
    margin: 0 auto;
  }
}

.date-picker-container.compact-layout {
  margin-top: 0.75rem;
  border-top: 1px solid #e5e7eb;
  padding-top: 0.75rem;
}

.date-picker-row.compact-repeat {
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
  margin-top: 15px;
}

.calendar-container.compact-calendar {
  flex: 0 0 auto;
  width: 265px;
  margin-right: 15px;
}

.repeat-options.compact-repeat {
  flex: 1;
  min-width: 320px; /* Increased to accommodate exclude days */
  max-width: none; /* Remove width constraint to prevent overflow */
  border-left: 1px solid #e5e7eb;
  padding-left: 20px;
  overflow: hidden; /* Prevent overflow */
  box-sizing: border-box;
}

.modal-date.compact-calendar {
  width: 265px;
  margin: 0 auto 10px auto;
  text-align: center;
}

.selected-date.compact-calendar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  font-size: 14px;
  color: #475569;
}

.selected-date.compact-calendar i {
  color: #3abf94;
}

::v-deep .vdp-datepicker__calendar.compact-calendar {
  width: 265px !important;
  border: 1px solid #e7e7e7;
  border-radius: 4px;
  padding: 6px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

/* Responsive styling for compact-calendar */
@media (max-width: 768px) {
  .date-picker-row.compact-repeat {
    flex-direction: column;
  }
  
  .calendar-container.compact-calendar {
    width: 100%;
    margin-right: 0;
    margin-bottom: 20px;
  }
  
  .repeat-options.compact-repeat {
    width: 100%;
    min-width: auto;
    max-width: 100%;
    border-left: none;
    padding-left: 0;
    border-top: 1px solid #e5e7eb;
    padding-top: 20px;
  }
  
  .modal-date.compact-calendar {
    margin: 0 auto;
  }
  
}

/* Day-row container uses flex so cells lay out as exactly 7 equal columns
   regardless of inline-block whitespace, font, or weight. Without this, with
   Montserrat at certain weights the 7×24px+margin+whitespace overflows the
   215px container and cells wrap mid-week, scrambling the visible numbers. */
.compact-layout ::v-deep .vdp-datepicker__calendar > div {
  display: flex;
  flex-wrap: wrap;
}

.compact-layout ::v-deep .vdp-datepicker__calendar .cell.day,
.compact-layout ::v-deep .vdp-datepicker__calendar .cell.day-header {
  flex: 0 0 14.285714%;
  width: 14.285714% !important;
  margin: 0 !important;
  padding: 0 1px !important;
  height: 26px !important;
  line-height: 26px !important;
  font-size: 0.85rem;
  box-sizing: border-box;
}

.compact-layout ::v-deep .vdp-datepicker__calendar .cell.day-header {
  font-size: 0.7rem;
  color: #64748b;
  font-weight: 600;
}

/* Month / Year picker views: 3 columns (library default) */
.compact-layout ::v-deep .vdp-datepicker__calendar .cell.month,
.compact-layout ::v-deep .vdp-datepicker__calendar .cell.year {
  flex: 0 0 33.333%;
  width: 33.333% !important;
  margin: 0 !important;
  padding: 0 !important;
  height: 32px !important;
  line-height: 32px !important;
  font-size: 0.85rem;
  box-sizing: border-box;
}

.compact-layout ::v-deep .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.compact-layout ::v-deep .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.compact-layout ::v-deep .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  border-color: #3abf94;
}

.compact-layout ::v-deep .vdp-datepicker__calendar .cell.selected {
  background: #3abf94;
  color: white;
}

.compact-layout {
  margin-bottom: 1rem;
  border-radius: 6px;
  overflow: hidden;
}

.compact-layout .date-picker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  padding-bottom: 0.25rem;
  border-bottom: none;
}

.compact-layout .date-picker-title {
  font-weight: 600;
  color: #334155;
  margin-bottom: 0;
  font-size: 0.9rem;
}

.compact-layout .date-picker-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 15px;
  width: 100%;
}

.compact-layout .calendar-container {
  flex: 0 0 215px;
  margin-right: 10px;
}

.compact-layout .repeat-options {
  flex: 1;
  min-width: 200px;
  border-left: 1px solid #e5e7eb;
  padding-left: 15px;
}

.compact-layout .modal-date {
  width: 215px !important;
  margin: 0;
  text-align: center;
}

.compact-layout ::v-deep .vdp-datepicker__calendar {
  width: 215px !important;
  font-size: 0.8rem;
  border: 1px solid #e7e7eb;
  border-radius: 4px;
  padding: 4px;
  margin: 0 auto;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.compact-layout .selected-date {
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  color: #475569;
}

.compact-layout .repeat-form {
  margin-top: 0;
  padding: 0.6rem;
  border-radius: 4px;
  background-color: #f8fafc;
}

.compact-layout .repeat-frequency {
  margin-bottom: 0.5rem;
}

.compact-layout .repeat-frequency label {
  font-size: 0.8rem;
  min-width: 45px;
}

.compact-layout .repeat-select-fixed {
  font-size: 0.8rem;
  padding: 0.25rem 1.5rem 0.25rem 0.5rem;
  min-height: 32px;
}

.compact-layout .daily-options,
.compact-layout .weekly-options, 
.compact-layout .monthly-options, 
.compact-layout .yearly-options {
  margin-top: 0.5rem;
  padding-top: 0.5rem;
}

.compact-layout .exclude-label,
.compact-layout .days-label {
  font-size: 0.8rem;
  margin-bottom: 0.25rem;
}

.compact-layout .exclude-checkboxes {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
  position: relative;
  overflow: visible;
}


.compact-layout .exclude-days {
  width: 100%;
  overflow: visible;
  position: relative;
}

.compact-layout .monthly-day-select,
.compact-layout .yearly-day-select {
  margin-bottom: 0.5rem;
  font-size: 0.8rem;
}

/* Responsive styling for compact layout */
@media (max-width: 768px) {
  .compact-layout .date-picker-row {
    flex-direction: column;
  }
  
  .compact-layout .calendar-container {
    width: 100%;
    margin-right: 0;
    margin-bottom: 15px;
  }
  
  .compact-layout .repeat-options {
    width: 100%;
    border-left: none;
    padding-left: 0;
    border-top: 1px solid #e5e7eb;
    padding-top: 15px;
  }
  
  .compact-layout .modal-date {
    margin: 0 auto;
  }
}

.wiki-count-badge {
  background-color: #dbeafe;
  color: #2563eb;
  font-size: 0.75rem;
  padding: 0.2rem 0.5rem;
  border-radius: 0.25rem;
  margin-left: 0.5rem;
}

.comment-count-badge {
  background-color: #dcfce7;
  color: #166534;
  font-size: 0.75rem;
  padding: 0.2rem 0.5rem;
  border-radius: 0.25rem;
  margin-left: 0.5rem;
}

/* *** NEW: Status Badge Styling (copied from TodoItem.vue) *** */
.status-badge {
  padding: 0.2rem 0.6rem;
  border-radius: 1rem; /* Pill shape */
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  display: inline-block;
  line-height: 1.2;
  white-space: nowrap;
}

.status-badge-completed {
  background-color: #dcfce7; /* Light green */
  color: #166534; /* Dark green */
}

.status-badge-overdue {
  background-color: #fef2f2; /* Light red */
  color: #dc2626; /* Dark red */
}

.status-badge-incomplete {
  background-color: #f1f5f9; /* Light grey */
  color: #64748b; /* Dark grey */
}
/* *** END NEW *** */

.todo-details-panel {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.task-content-editable {
  border: 1px solid #e9ecef;
  padding: 10px;
  min-height: 80px;
  border-radius: 4px;
  margin-bottom: 15px;
  background-color: #fff;
  &:focus {
    outline: none;
    border-color: #3abf94;
    box-shadow: 0 0 0 3px rgba(58, 191, 148, 0.3);
  }
}

/* Task ID Display Styles */
.task-id-section {
  display: flex;
  align-items: center;
  gap: 5px; /* Spacing between elements */
  font-size: 0.8rem; /* Smaller font size */
  color: #64748b; /* Muted text color */
  /* Removed mb-3 */
}

.task-id-text {
  font-family: monospace;
  background-color: #f1f5f9; /* Lighter background */
  padding: 2px 5px;
  border-radius: 3px;
  color: #475569; /* Slightly darker text */
  font-weight: 500;
}

.copy-button {
  color: #64748b; /* Muted color */
  text-decoration: none;
  cursor: pointer;
  font-size: 0.9rem; /* Slightly larger icon */
  &:hover {
    color: #3abf94; /* Theme color on hover */
  }
  i {
     transition: color 0.2s ease-in-out;
  }
  .text-success {
    color: #16a34a !important; /* Ensure success color overrides */
  }
}

/* Assignee Multiselect Styles */
.assignee-section {
    min-height: 40px; /* Ensure space for multiselect */
}

.assignee-multiselect-wrapper {
  position: relative;
  z-index: 10; /* Ensure dropdown appears above date picker */
}

.assignee-multiselect ::v-deep .multiselect__tags {
  min-height: 40px;
  border: 1px solid #cbd5e1;
  border-radius: 0.375rem;
  padding: 0.25rem 2.5rem 0.25rem 0.5rem;
  display: flex; /* Ensure flex display */
  flex-wrap: wrap; /* Allow wrapping */
  align-items: center; /* Vertically center items */
  gap: 0.25rem; /* Add gap for spacing between tags */
}

.assignee-multiselect ::v-deep .multiselect__placeholder {
  padding-left: 0.25rem;
  color: #94a3b8;
}

.assignee-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.small-avatar {
  width: 20px;
  height: 20px;
  font-size: 0.6rem;
  border: none;
}

.assignee-option-name {
  font-size: 0.875rem;
}

.assignee-tag {
  display: inline-flex;
  align-items: center; // Good, already using flex for alignment
  vertical-align: middle; /* Explicitly align vertically */
  gap: 0.3rem; // Space between avatar and name
  background-color: #e0f2fe; // Light blue background
  color: #0369a1; // Darker blue text
  border-radius: 0.25rem;
  padding: 0.25rem 0.5rem; // Increased padding (top/bottom, left/right)
  /* Remove margins, let container gap handle spacing */
  /* margin-right: 0.3rem; */
  /* margin-bottom: 0.25rem; */
}

.assignee-tag span { // The name text within the tag
    font-size: 0.8125rem; // Slightly larger font size
}

.assignee-tag .multiselect__tag-icon { // The 'x' remove icon
    margin-left: 0.2rem;
    width: 16px;
    height: 16px;
    line-height: 1;
}

/* NEW Style for the avatar image itself */
.avatar-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* Replicates background-size: cover */
  object-position: center; /* Replicates background-position: center */
  border-radius: inherit; /* Ensure image matches parent's border radius */
  display: block; /* Ensure it takes up space */
}

/* NEW Style for the avatar image itself */
/* Increase specificity by including parent */
.avatar-circle > .avatar-image,
.avatar > .avatar-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* Replicates background-size: cover */
  object-position: center; /* Replicates background-position: center */
  border-radius: inherit; /* Ensure image matches parent's border radius */
  display: block; /* Ensure it takes up space */
}

/* Class to hide images that failed to load - higher specificity to override above */
.avatar-circle > .avatar-image.avatar-hidden,
.avatar > .avatar-image.avatar-hidden {
  display: none !important;
  visibility: hidden;
}

/* ============================================
   SUBTASKS SECTION STYLES
   ============================================ */
.subtasks-section {
  margin-bottom: 1rem;
}

.new-feature-badge {
  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
  color: #ffffff;
  font-size: 0.625rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0.15rem 0.5rem;
  border-radius: 4px;
  margin-left: 0.5rem;
  display: inline-block;
  animation: pulse-glow 2s ease-in-out infinite;
  box-shadow: 0 2px 4px rgba(249, 115, 22, 0.3);
}

@keyframes pulse-glow {
  0%, 100% {
    box-shadow: 0 2px 4px rgba(249, 115, 22, 0.3);
  }
  50% {
    box-shadow: 0 2px 8px rgba(249, 115, 22, 0.5);
  }
}

.subtask-progress-badge {
  background-color: #dbeafe;
  color: #1d4ed8;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.25rem 0.6rem;
  border-radius: 10px;
  margin-left: 0.5rem;
  min-width: 2.5rem;
  text-align: center;
  display: inline-block;
}

.subtasks-panel {
  padding: 1rem 1.25rem;
}

.subtasks-container {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

/* Progress Bar */
.subtasks-progress {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.progress-bar-container {
  flex: 1;
  height: 6px;
  background-color: #e2e8f0;
  border-radius: 3px;
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #3abf94 0%, #22c55e 100%);
  border-radius: 3px;
  transition: width 0.3s ease;
}

.progress-text {
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 500;
  white-space: nowrap;
}

/* Subtask List */
.subtask-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.subtask-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.625rem 0.75rem;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.subtask-item:hover {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
}

.subtask-item.subtask-completed {
  background-color: #f0fdf4;
  border-color: #bbf7d0;
}

.subtask-checkbox-wrapper {
  flex-shrink: 0;
}

.subtask-checkbox {
  width: 22px;
  height: 22px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s ease;
}

.subtask-checkbox:hover {
  transform: scale(1.1);
}

.subtask-checkbox i {
  font-size: 1.1rem;
  color: #94a3b8;
  transition: color 0.2s ease;
}

.subtask-checkbox:hover i {
  color: #3abf94;
}

.subtask-checkbox.is-checked i {
  color: #22c55e;
}

.subtask-content {
  flex: 1;
  font-size: 0.875rem;
  color: #334155;
  line-height: 1.4;
}

.subtask-content.completed-text {
  text-decoration: line-through;
  color: #94a3b8;
}

/* Drag Handle */
.subtask-drag-handle {
  flex-shrink: 0;
  width: 20px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  opacity: 0.4;
  transition: opacity 0.2s ease;
}

.subtask-drag-handle:active {
  cursor: grabbing;
}

.subtask-item:hover .subtask-drag-handle {
  opacity: 1;
}

.subtask-drag-handle i {
  font-size: 0.75rem;
  color: #94a3b8;
}

.subtask-drag-handle:hover i {
  color: #64748b;
}

/* Ghost class for dragging */
.subtask-ghost {
  opacity: 0.5;
  background-color: #dbeafe !important;
  border: 1px dashed #3b82f6 !important;
}

/* Dragging state */
.subtask-item.sortable-chosen {
  background-color: #f0fdf4;
  border-color: #3abf94;
  box-shadow: 0 4px 12px rgba(58, 191, 148, 0.15);
}

.subtask-delete-btn {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.2s ease;
  border-radius: 4px;
}

.subtask-item:hover .subtask-delete-btn {
  opacity: 1;
}

.subtask-delete-btn:hover {
  background-color: #fee2e2;
}

.subtask-delete-btn i {
  font-size: 0.75rem;
  color: #94a3b8;
}

.subtask-delete-btn:hover i {
  color: #ef4444;
}

/* Empty State */
.subtasks-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem 1rem;
  text-align: center;
}

.subtasks-empty .empty-icon {
  font-size: 2rem;
  color: #cbd5e1;
  margin-bottom: 0.5rem;
}

.subtasks-empty p {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: #64748b;
}

.subtasks-empty .empty-hint {
  font-size: 0.75rem;
  color: #94a3b8;
  margin-top: 0.25rem;
}

/* Add Subtask Input */
.add-subtask-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.add-subtask-input-wrapper {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
}

.add-subtask-input-wrapper .add-icon {
  position: absolute;
  left: 0.75rem;
  font-size: 0.8rem;
  color: #94a3b8;
  pointer-events: none;
}

.add-subtask-input {
  width: 100%;
  padding: 0.5rem 0.75rem 0.5rem 2.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.875rem;
  color: #334155;
  background-color: #fff;
  transition: all 0.2s ease;
}

.add-subtask-input:focus {
  outline: none;
  border-color: #3abf94;
  box-shadow: 0 0 0 3px rgba(58, 191, 148, 0.15);
}

.add-subtask-input::placeholder {
  color: #94a3b8;
}

.add-subtask-btn {
  flex-shrink: 0;
  padding: 0.5rem 1rem;
  background-color: #3abf94;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.add-subtask-btn:hover:not(:disabled) {
  background-color: #2ea37e;
}

.add-subtask-btn:disabled {
  background-color: #cbd5e1;
  cursor: not-allowed;
}
/* ============================================
   END SUBTASKS SECTION STYLES
   ============================================ */
</style>